import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import MuiAlert from "@mui/material/Alert";
import {
  fetchDeleteData,
  fetchData,
  fetchAllData,
  uploadPdf,
  fetchUpdateData
} from "../../helpers/externapi";
import Snackbar from "@mui/material/Snackbar";
import CardEditForms from "../../Components/CardEditForms";
import SelectNominee from "../../Components/SelectNominee";
import TableContainer from "@mui/material/TableContainer";
import ConfirmationDialogDelete from "../../Components/ConfirmationDialogDelete";
import Paper from "@mui/material/Paper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faIndianRupeeSign } from "@fortawesome/free-solid-svg-icons";
import {
  fetchConfigValues,
  formatDate,
  formatDate1,
} from "../../Commoncomponents/CommonComponents";
import Cleave from "cleave.js/react";
import { Box, Button, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function AdvisorPersonalDetails(props) {
  const [profile, setProfile] = useState(props.data);
  const [file, setFile] = useState();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [PolicyCOINumber, setPolicyCOINumber] = useState("");
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [callResponseOptions, setCallResponseOptions] = useState([]);
  const [activeTab, setActiveTab] = useState("callHistory");
  const [formError, setFormError] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const [formVisible, setFormVisible] = useState(false);
  const [callHistory, setCallHistory] = useState([]);
  const [cardDetails, setCardDetails] = useState([]);
  const [loading, setLoading] = useState();
  const [products, setProducts] = useState([]);
  const [showNominee, setShowNominee] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showProductDetailsTab, setShowProductDetailsTab] = useState(false);
  const initialFormData = {
    callHistoryId: "",
    callLog: "",
    CollectedDate: "",
    callResponsesId: "",
    DateToBeVisited: "",
  };
  const [formData, setFormData] = useState(initialFormData);
  const [isFormValid, setIsFormValid] = useState(false);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [confirmationData, setConfirmationData] = useState({});
  const [availableProducts, setAvailableProducts] = useState();
  const [memberDetails, setMemberDetails] = useState();
  const [purchaseProduct, setPurchaseProduct] = useState();
  const [utrNumber, setUtrNumber] = useState("");
  const [utrError, setUtrError] = useState(false);
  const [paymentSuccessMsg, setPaymentSeccessMsg] = useState(false);
  const [comboProductDetails, setComboProductDetails] = useState([]);
  const [familyMembersLength, setFamilyMembesLength] = useState();
  const [cardNumberEntered, setCardNumberEntered] = useState(false);
  const [cardNumber, setCardNumber] = useState("2804 00");
  const [cardNumberError, setCardNumberError] = useState(null);
  const [memberPrdAddFail, setMemberProdAddFail] = useState("");
  const [paymentFailureError, setPaymentFailureError] = useState("");
  const [updatePaymentForProductError, setUpdatePaymentForProductError] =
    useState("");
  const [cardAddError, setCardAddError] = useState("");
  const [utrSubmitLoad, setUtrSubmitLoad] = useState(false);
  const [base64, setBase64] = useState(null);
  const [paUrl, setPaUrl] = useState("");
  const [policyUploadLoad, setPolicyUploadLoad] = useState(false);
  const [isFlipped, setIsFlipped] = useState(false);
  const [policies, setPolicies] = useState([]);
  const [selectedPolicy, setSelectedpolicy] = useState();
  const [cardNumbers, setCardNumbers] = useState([
    { cardNumber: "2804 00", error: "" },
  ]);
  const [distributorCards, setDistributorCards] = useState([]);
  const [cardsNumberError, setCardsNumberError] = useState("");
  const [noOfAssigns, setNoOfAssigns] = useState(null);
  const [cardLoading, setCardLoading] = useState(false);
  const [callHistoryLoading, setCallHistoryLoading] = useState(false);
  const [productsLoading, setProductsLoading] = useState(false);
  const [isBookServiceHovered, setIsBookServiceHovered] = useState(false);
  const [gmcLoading, setGmcLoading] = useState(false);
  const [selectedIndividualProduct, setSelectedIndividualPrdouct] = useState();
  const [showIndividualProducts, setShowIndividualProducts] = useState(false);
  const [cardFrontImage, setCardFrontImage] = useState(null);
  const [cardBackImage, setCardBackImage] = useState(null);
  const [addFormData, setAddFormData] = useState({
    AddressLine1: "",
    AddressLine2: "",
    StateName: "",
    StateId: "",
    DistrictName: "",
    DistrictId: "",
    City: "",
    Pincode: "",
    Village: "",
    Mandal: "",
    UserId: "",
    UserName: "",
    RmId: "",
    Table: "",
  });
  const [districtDropdown, setDistrictDropdown] = useState([]);
  const [stateDropdown, setStateDropdown] = useState([]);
  const [rmOptions, setRmOptions] = useState([]);
  const [selectedRM, setSelectedRM] = useState(profile?.JoinedBy || "");
  const [selectedReporting, setSelectedReporting] = useState(profile?.ReportingId || "");
  const [isEditingRM, setIsEditingRM] = useState(false);
  const [isEditingReporting, setIsEditingReporting] = useState(false);
  const [activeSection, setActiveSection] = useState("product");
  const isFetching = useRef(false);
  const [imageUrl, setImageUrl] = useState('');

  const [customerId, setCustomerId] = useState(null);

  const UserId = localStorage.getItem("UserId");
  const { Id } = useParams();
  const navigate = useNavigate();

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  useEffect(() => {
    const getPAUrl = async () => {
      const { policiesDownloadURL, CardFront, CardBack, userImagesBucketlink } = await fetchConfigValues();

      setCardFrontImage(CardFront);
      setPaUrl(policiesDownloadURL);
      setCardBackImage(CardBack);
      if (userImagesBucketlink) {
        setImageUrl(userImagesBucketlink);
      }
    };

    getPAUrl();
  }, []);

  useEffect(() => {
    const isFormValid = formData.callResponsesId.length > 0;
    setIsFormValid(isFormValid);
  }, [formData]);

  useEffect(() => {
    const getCallResponse = async () => {
      setLoading(true);
      try {
        const getResponseTypes = await fetchData("CallResponseType/all", {
          skip: 0,
          take: 0,
        });

        let CallResponseTypeId = getResponseTypes.filter(
          (types) => types.ResponseName === "Member"
        );

        const response = await fetchAllData(
          `CallResponse/GetCallResponsesByResponseType/${CallResponseTypeId[0].CallResponseTypeId}`
        );
        setCallResponseOptions(response);
      } catch (error) {
        console.error("Error fetching call responses:", error);
      } finally {
        setLoading(false);
      }
    };

    const getAvailableProducts = async () => {
      setLoading(true);
      try {
        if (
          cardDetails &&
          products &&
          cardDetails.status &&
          products.length > 0
        ) {
          const response = await fetchAllData(
            `MembersProducts/GetProductForMember/${memberDetails[0].MemberId}`
          );
          setAvailableProducts(response);
        } else {
          const response = await fetchData("Products/all", {
            skip: 0,
            take: 0,
          });

          let getCombo = [];

          response &&
            response.length > 0 &&
            response.map((each) => {
              if (each.IsCombo) {
                getCombo = [...getCombo, each];
              }
            });

          setAvailableProducts(getCombo);
        }
      } catch (error) {
        console.error("Error fetching available products: ", error);
      }
    };

    getAvailableProducts();
    getCallResponse();
  }, [memberDetails, products]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setCardLoading(true);
        const response = await fetchAllData(
          `lambdaAPI/OHOCards/GetMemberCardByMemberId/${customerId}`
        );
        setCardDetails(response);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setCardLoading(false);
      }
    };
    fetchData();
  }, [customerId]);



  const fetchProductsData = async () => {
    try {
      setProductsLoading(true);
      const response = await fetchAllData(`lambdaAPI/Customer/GetMemberProducts/${customerId}`);

      setProducts(response[0].Products);
      setPolicies(response[0].Products[0].Policies);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setProductsLoading(false);
    }
  };


  const fetchMemberData = async () => {
    setLoading(true);
    try {
      const response = await fetchAllData(`lambdaAPI/Employee/GetById/${Id}`);
      setMemberDetails(response[0]);
      setCustomerId(response[0].CustomerId);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };


  useEffect(() => {

    fetchMemberData();


  }, [Id]);

  useEffect(() => {
    if (customerId) {
      fetchProductsData();
    }
  }, [customerId])

  const handleCardNumberChange = (e) => {
    // Extract only digits after the default prefix "2804 00"
    let input = e.target.value.replace(/\D/g, "").substring(6);

    // Limit to 6 digits for the user-input portion
    if (input.length > 6) {
      input = input.slice(0, 6);
    }

    // Format as "2804 00XX XXXX"
    const formattedCardNumber = `2804 00${input.slice(0, 2)} ${input.slice(
      2
    )}`.trim();
    setCardNumber(formattedCardNumber);
  };

  const checkCardNumberExists = async () => {
    try {
      const response = await fetchData("OHOCards/cardNumberExistorNot", {
        cardNumber,
        rmId: UserId,
        memberId: Id,
      });
      if (response.status === true) {
        setCardNumberEntered(true);
        setCardNumberError(null);
      } else {
        setCardNumberError(response.message);
      }
    } catch (error) {
      setCardNumberError(
        "An error occurred while checking the card number. Please try again."
      );
    }
  };

  const handleProductClick = async (product) => {
    // setSelectedProduct((prevProduct) =>
    //     prevProduct && prevProduct.ProductsId === product.ProductsId ? null : product
    // );

    setSelectedProduct(product);

    const details = await fetchAllData(
      `ComboProducts/FetchComboProducts/${product.ProductsId}`
    );
    setComboProductDetails(details);

    const response = await fetchAllData(
      `MemberDependent/GetDependentsByMemberProductId/${Id}/${product.ProductsId}`
    );
    setFamilyMembesLength(response.length);

    const isSameProduct =
      selectedProduct && selectedProduct.ProductsId === product.ProductsId;
    setShowNominee(true);
    // if (isSameProduct) {
    //     setIsEditing(true);
    //     setShowProductDetailsTab(true);
    //     setActiveTab('products');
    // } else {
    setShowProductDetailsTab(true);
    setActiveTab("products");
    // }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetchAllData(`Dependent/GetMemberById/${Id}`);
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setProfile(data);
        setFormData(data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [Id]);

  const handleDelete = () => {
    setConfirmationData({
      title: "Delete Member",
      message: "Are you sure you want to delete this Member?",
      onConfirm: () => confirmhandleDelete(),
    });
    setConfirmationOpen(true);
  };

  const confirmhandleDelete = async () => {
    try {
      const response = await fetchDeleteData(`lambdaAPI/Employee/delete/${Id}`);
      if (response.status === false) {
        setSnackbarMessage(response.message);
        setSnackbarOpen(true);
        return;
      }
      setSnackbarMessage(`Deleted Successfully`);
      setSnackbarOpen(true);

      setTimeout(() => {
        navigate("/advisor/list");
      }, 2000);
    } catch (error) {
      console.error("Error deleting event:", error);
      setSnackbarMessage("Failed to delete. Please try again.");
      setSnackbarOpen(true);
    }
  };

  const fetchCallHistoryData = async () => {
    setLoading(true);
    try {
      setCallHistoryLoading(true);
      const response = await fetchAllData(
        `lambdaAPI/CallHistory/GetAllCallHistoryByEmployeeId/${Id}`
      );
      setCallHistory(response);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    } finally {
      setCallHistoryLoading(false);
    }
  };

  useEffect(() => {
    fetchCallHistoryData();
  }, [Id]);

  const EditAddress = async () => {
    try {
      setLoading(true);

      const addressUpdateData = [
        {
          columnName: "AddressLine1",
          columnValue: addFormData.AddressLine1,
          tableName: "Employee",
          tableId: Id,
          UpdatedBy: UserId,

        },
        {
          columnName: "AddressLine2",
          columnValue: addFormData.AddressLine2,
          tableName: "Employee",
          tableId: Id,
          UpdatedBy: UserId,
        },
        {
          columnName: "StateId",
          columnValue: addFormData.StateId,
          tableName: "Employee",
          tableId: Id,
          UpdatedBy: UserId,
        },
        {
          columnName: "DistrictId",
          columnValue: addFormData.DistrictId,
          tableName: "Employee",
          tableId: Id,
          UpdatedBy: UserId,
        },
        {
          columnName: "city",
          columnValue: addFormData.City,
          tableName: "Employee",
          tableId: Id,
          UpdatedBy: UserId,
        },
        {
          columnName: "Pincode",
          columnValue: addFormData.Pincode,
          tableName: "Employee",
          tableId: Id,
          UpdatedBy: UserId,
        },
        {
          columnName: "Village",
          columnValue: addFormData.Village,
          tableName: "Employee",
          tableId: Id,
          UpdatedBy: UserId,
        },
        {
          columnName: "Mandal",
          columnValue: addFormData.Mandal,
          tableName: "Employee",
          tableId: Id,
          UpdatedBy: UserId,
        },
      ];

      const EditData = await fetchUpdateData(
        "lambdaAPI/Update/CommonUpdate",
        addressUpdateData
      );

      if (EditData) {
        alert("Address updated successfully!");
        setIsEditing(false);

        setTimeout(() => {
          window.location.reload();
        }, 500);

      }


    } catch (error) {
      console.error("Error updating address:", error);
    } finally {
      setLoading(false);
      setIsEditing(false);
    }
  };

  const handleRMUpdate = async () => {
    if (isFetching.current) return;
    isFetching.current = true;

    try {
      setLoading(true);

      // Fetch all RM names to get the UserId of the selected RM
      const usersData = await fetchAllData(`lambdaAPI/Employee/GetRMNames`);
      setRmOptions(
        usersData?.map((user) => ({
          label: user.UserName,
          value: user.UserId,
        })) || []
      );

      // Find the UserId of the selected RM
      const selectedUser = usersData?.find((user) => user.UserId === selectedRM);
      const selectedUserId = selectedUser ? selectedUser.UserId : null;



      const updateData = [
        {
          columnName: "JoinedBy",
          columnValue: selectedRM,
          tableName: "Employee",
          tableId: Id,
        },
      ];

      const response = await fetchUpdateData("lambdaAPI/Update/CommonUpdate", updateData);



      if (response) {
        alert("RM updated successfully!");
        setIsEditingRM(false);

        setTimeout(() => {
          window.location.reload();
        }, 500); // Reloads the page after 1 second
      }

    } catch (error) {
      console.error("Error updating RM:", error);
      alert("Failed to update RM.");
    } finally {
      setLoading(false);
      isFetching.current = false;
    }
  };

  const handleReportingUpdate = async () => {
    if (isFetching.current) return;
    isFetching.current = true;

    try {
      setLoading(true);

      // Fetch all RM names to get the UserId of the selected RM
      const usersData = await fetchAllData(`lambdaAPI/Employee/GetRMNames`);
      setRmOptions(
        usersData?.map((user) => ({
          label: user.UserName,
          value: user.UserId,
        })) || []
      );

      // Find the UserId of the selected RM
      const selectedUser = usersData?.find((user) => user.UserId === selectedRM);
      const selectedUserId = selectedUser ? selectedUser.UserId : null;



      const updateData = [
        {
          columnName: "ReportingTo",
          columnValue: selectedReporting,
          tableName: "Employee",
          tableId: Id,
        },
      ];

      const response = await fetchUpdateData("lambdaAPI/Update/CommonUpdate", updateData);



      if (response) {
        alert("Reporting updated successfully!");
        setIsEditingRM(false);

        setTimeout(() => {
          window.location.reload();
        }, 500); // Reloads the page after 1 second
      }

    } catch (error) {
      console.error("Error updating Reporting:", error);
      alert("Failed to update Reporting.");
    } finally {
      setLoading(false);
      isFetching.current = false;
    }
  };

  useEffect(() => {
    const getStateDropdown = async () => {
      try {
        const statesData = await fetchData("States/all", { UserId });


        if (Array.isArray(statesData)) {
          setStateDropdown(statesData);
        } else {
          console.error("States data is not an array:", statesData);
          setStateDropdown([]);
        }
      } catch (error) {
        console.error("Error fetching states:", error);
      }
    };

    if (UserId) getStateDropdown();
  }, [UserId]);

  // Fetch Districts based on StateId
  const getDistricts = async (stateId) => {
    if (!stateId) return;

    try {
      const districtsData = await fetchAllData(`Districts/GetByStateId/${stateId}`);
      setDistrictDropdown(districtsData);
    } catch (error) {
      console.error("Error fetching districts:", error);
    }
  };

  // Handle State Selection
  const handleStateChange = (e) => {
    const selectedStateId = e.target.value;


    setAddFormData((prevData) => ({
      ...prevData,
      StateId: selectedStateId,
      DistrictId: "",
    }));

    getDistricts(selectedStateId);
  };


  const handleDistrictChange = (e) => {
    const districtId = e.target.value;


    setAddFormData((prevData) => ({
      ...prevData,
      DistrictId: districtId,
    }));
  };


  useEffect(() => {
    if (addFormData.StateId) {
      getDistricts(addFormData.StateId);
    }
  }, [addFormData.StateId]);


  useEffect(() => {

  }, [districtDropdown]);


  useEffect(() => {

  }, [districtDropdown]);

  const getRegionalManagers = async (rmId = null) => {

    if (isFetching.current) return;
    isFetching.current = true;
    try {
      if (rmId) {

        const userData = await fetchAllData(`Users/GetRMById?rmId${Id}`);
        setSelectedRM(userData?.UserId)
        setSelectedReporting(userData?.UserId)
        setProfile((prev) => ({
          ...prev,
          RMName: userData?.UserName || "Not exist",
        }));
      } else {

        const usersData = await fetchAllData(`lambdaAPI/Employee/GetRMNames`);
        setRmOptions(
          usersData?.map((user) => ({
            label: user.UserName,
            value: user.UserId,
          })) || []
        );
      }
    } catch (error) {
      console.error("Error fetching RM data:", error);
    } finally {
      isFetching.current = false;
    }
  };



  const handleBackToView = () => {
    setFormVisible(false);
  };

  const formatCardNumber = (cardNumber) => {
    if (!cardNumber) return "";
    const chunks = cardNumber.replace(/\s/g, "").match(/.{1,4}/g);
    return chunks.join(" ");
  };

  const handlePrint = () => {
    // Concatenate the address as needed
    const addAddress = () => {
      let address = "";
      selectedProduct.AddressLine1 &&
        (address = `${address} ${selectedProduct.AddressLine1}`);
      selectedProduct.AddressLine2 &&
        (address = `${address}, ${selectedProduct.AddressLine2}`);
      selectedProduct.Village &&
        (address = `${address}, ${selectedProduct.Village}`);
      selectedProduct.City && (address = `${address}, ${selectedProduct.City}`);
      selectedProduct.Mandal &&
        (address = `${address}, ${selectedProduct.Mandal}`);
      selectedProduct.District &&
        (address = `${address}, ${selectedProduct.District}`);
      selectedProduct.State &&
        (address = `${address}, ${selectedProduct.State}`);
      selectedProduct.pincode &&
        (address = `${address}, ${selectedProduct.pincode}`);
      return address;
    };

    const recipientName = selectedProduct.Name || "Recipient Name";
    const recipientMobile = selectedProduct.MobileNumber || "Mobile Number";

    const fromAddress = `
    OHOINDIA LIFE TECH PVT. LTD<br>
    5th Floor, 1-98/9/4/20,<br>
    Arunodaya Colony, VIP Hills,<br>
    Hi-Tech City, Madhapur,<br>
    Hyderabad, Telangana 500081<br>
    Mobile No. 7671997108
    `;

    const appDetails = `
    <div style="text-align: center; padding: 10px; margin-bottom: 20px;">
        <img src="${process.env.PUBLIC_URL}/assets/applogo.png" height="50" alt="App Logo" /><br>
        <strong>OHOINDIA</strong><br>
        Website:- www.ohoindialife.com<br>
        Contact No:- 7671997108 / 7032107108<br>
        Email:- contact@ohoindialife.com<br>
    </div>
    `;

    const printWindow = window.open("", "", "width=396,height=912");
    printWindow.document.write("<html>");
    printWindow.document.write(`
    <style>
        @page {
            size: 4.125in 9.5in;
            margin: 0;
        }
        body {
            font-family: Arial, sans-serif;
            padding: 20px;
        }
        .box {
            border: 1px solid black;
            padding: 10px;
            margin-bottom: 20px;
        }
        h5 {
            margin: 0;
        }
    </style>
    `);
    printWindow.document.write("<body>");
    printWindow.document.write(appDetails);
    printWindow.document.write(`
    <div class="box">
        <strong>From:</strong><br>
        ${fromAddress}
    </div>
    <div class="box">
        <strong>To:</strong><br>
        <h5>${recipientName}</h5>
        ${addAddress()}<br>
        <strong>Mobile:</strong> ${recipientMobile}
    </div>
    `);
    printWindow.document.write("</body></html>");
    printWindow.document.close();
    printWindow.print();
  };

  const handleUploadChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFile(file);

      const reader = new FileReader();

      reader.onload = () => {
        if (reader.result) {
          setBase64(reader.result.toString());
        }
      };

      reader.readAsDataURL(file);
    }
  };

  const handleFileSubmit = async (e) => {
    e.preventDefault();
    const content = base64.split("base64,");

    const formData = new FormData();
    formData.append("MemberId", customerId);
    formData.append("productsId", selectedPolicy.PoliciesProductsId);
    formData.append(
      "individualProductsId",
      selectedPolicy.IndividualProductsId
    );
    formData.append("memberProductId", selectedPolicy.PoliciesMemberProductId);
    formData.append("policyDocument", file);
    formData.append("PolicyCOINumber", PolicyCOINumber);
    formData.append("FileContent", content[1]);

    try {
      setPolicyUploadLoad(true);

      const uploadFile = await uploadPdf(
        "lambdaAPI/Subscription/uploadingPolicyDoc",
        formData
      );
      setSnackbarMessage(uploadFile.message);
      setSnackbarOpen(true);
      setPolicyUploadLoad(false);

      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const handleGenerateMembership = async () => {
    try {
      setGmcLoading(true);

      const { policiesDownloadURL } = await fetchConfigValues();

      if (!policiesDownloadURL) {
        console.error("Policies download URL configuration not found.");
        alert("Unable to download PDF. Configuration missing.");
        return;
      }

      const bucketUrl = policiesDownloadURL;

      const response = await fetchData("lambdaAPI/Payment/PolicyGeneration", {
        memberId: customerId,
        productsId: selectedProduct.ProductsId,
        memberProductId: selectedProduct.MemberProductId,
      });

      const { status, message, data } = response || {};

      if (status && data) {
        const downloadUrl = `${bucketUrl}${data}`;

        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = data;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.error(
          "File generation failed or data is missing. Status:",
          status,
          "Message:",
          message
        );
        alert("Unable to download PDF. " + message);
      }
    } catch (error) {
      console.error("Error downloading membership PDF:", error);
      alert("An error occurred while trying to download the PDF.");
    } finally {
      setGmcLoading(false);
    }
  };

  const onSubmitHandler = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      let CallHistoryData;
      const requestData = {
        callLog: formData.callLog,
        EmployeeId: Id,
        userId: UserId,
        callResponsesId: formData.callResponsesId,
        DateToBeVisited:
          formData.DateToBeVisited === "" ? null : formData.DateToBeVisited,
        RequestCallBack:
          formData.RequestCallBack === "" ? null : formData.RequestCallBack,
      };

      // if (formData.DateToBeVisited) {
      //     requestData.DateToBeVisited = new Date(formData.DateToBeVisited).toISOString();
      // }

      // if (formData.RequestCallBack) {
      //     requestData.RequestCallBack = new Date(formData.RequestCallBack).toISOString();
      // }

      // if (isEditing) {
      //     requestData.callHistoryId = formData.callHistoryId;
      //     CallHistoryData = await fetchUpdateData('CallHistory/update', requestData);
      //     setSnackbarMessage("Call log updated successfully!");
      // } else {
      CallHistoryData = await fetchData("lambdaAPI/CallHistory/add", requestData);
      setSnackbarMessage("New call log added successfully!");
      // }

      setCallHistory(CallHistoryData);
      setSnackbarOpen(true);
      setIsEditing(false);

      await fetchCallHistoryData();
    } catch (error) {
      console.error("Error adding call log:", error);
    } finally {
      setLoading(false);
      setFormVisible(false);
      setFormData(initialFormData);
    }
  };

  const handleEditForm = () => {
    navigate("/advisor/new", { state: { profile } });
  };

  const handleResetForm = () => {
    setFormData(initialFormData);
    setFormError({});
  };

  const onChangeHandler = (event) => {
    const { name, value, type, checked } = event.target;
    let updatedFormData = {
      ...formData,
      [name]: type === "checkbox" ? (checked ? value : "") : value,
    };
    let error = "";

    //if (name === 'DateToBeVisited' && value.length === 10) {
    //    const defaultTime = "T00:00:00";
    //    updatedFormData = { ...updatedFormData, DateToBeVisited: `${value}${defaultTime}` };
    //}
    setFormData(updatedFormData);
    setFormError({ ...formError, [name]: error });
  };

  const cardActiveAndDeactive = async () => {
    const isActivated =
      cardDetails.returnData[0].IsActivated === null
        ? true
        : cardDetails.returnData[0].IsActivated === false
          ? true
          : false;

    const updateApi = await fetchData("lambdaAPI/OHOCards/ActivateorDeactivateTheCard", {
      customerId,
      isActivated,
    });

    window.location.reload();
  };

  const handleUpdateActivated = (message) => {
    setConfirmationData({
      title: `${message} Caed`,
      message: `Are you sure you want to ${message} this Card?`,
      onConfirm: () => cardActiveAndDeactive(),
    });
    setConfirmationOpen(true);
  };

  const onChangeUtrNumber = (e) => {
    setUtrNumber(e.target.value);
  };

  const submitUtrForm = async (e) => {
    e.preventDefault();

    if (utrNumber && utrNumber.length >= 10) {
      setUtrError(false);
      setUtrSubmitLoad(true);

      const memberProductPayload = {
        productsId: purchaseProduct.ProductsId,
        memberId: memberDetails[0].MemberId,
        userId: UserId,
      };

      const responseMemberProductAdd = await fetchData(
        "MembersProducts/add",
        memberProductPayload
      );

      if (responseMemberProductAdd && responseMemberProductAdd.length > 0) {
        setMemberProdAddFail("");

        const paymentPayload = {
          paidAmount: purchaseProduct.SaleAmount,
          utrNumber: utrNumber,
          typeofCard: "Privilege",
          memberProductId: responseMemberProductAdd[0].memberProductId,
          memberId: memberDetails[0].MemberId,
        };

        const responsePayment = await fetchData(
          "PaymentDetails/add",
          paymentPayload
        );

        if (responsePayment && responsePayment.paymentDetailsId) {
          setPaymentFailureError("");

          const paymentMemberProductPayload = {
            productsId: responseMemberProductAdd[0].productsId,
            memberId: memberDetails[0].MemberId,
            paymentDetailsId: responsePayment.paymentDetailsId,
          };

          const responsePaymentMemberProduct = await fetchData(
            "PaymentDetails/UpdatePaymentIdInMemberProduct",
            paymentMemberProductPayload
          );

          if (responsePaymentMemberProduct) {
            setUpdatePaymentForProductError("");

            const ohoCardPayload = {
              ohoCardsId: 0,
              ohoCardNumber: cardNumber,
              assignedToRM: UserId,
              assignedToMember: memberDetails[0].MemberId,
              cardPurchasedMemberId: memberDetails[0].MemberId,
              productsId: responseMemberProductAdd[0].productsId,
              userId: UserId,
            };

            const responseOhoCard = await fetchData(
              "OHOCards/add",
              ohoCardPayload
            );

            setPaymentSeccessMsg(true);
            if (responseOhoCard && responseOhoCard.status) {
              setCardAddError("");
              setPaymentSeccessMsg(true);
              setTimeout(() => {
                setPurchaseProduct();
                setPaymentSeccessMsg(false);
                setUtrNumber("");
                setUtrError(false);
                setUtrSubmitLoad(false);
                window.location.reload();
              }, 2000);
            } else {
              setUtrSubmitLoad(false);
              setCardAddError(
                "Sorry, Failed to add card. Please contact Technical team"
              );
              console.error("Failed to generate OHO card:", responseOhoCard);
            }
          } else {
            setUtrSubmitLoad(false);
            setUpdatePaymentForProductError(
              "Sorry, Failed to update payment for product. Please contact technical team"
            );
          }
        } else {
          setUtrSubmitLoad(false);
          setPaymentFailureError(
            "Sorry payment failed. Please contact technical team."
          );
        }
      } else {
        setUtrSubmitLoad(false);
        setMemberProdAddFail(
          "Sorry, Failed to add product. Please contact technical team"
        );
      }
    } else {
      setUtrError(true);
    }
  };

  const handleBookService = async (e) => {
    e.preventDefault();
    navigate("/HospitalConsultation/book", {
      state: { memberId: customerId },
    });
  };

  const handleSelectPolicy = (data) => {
    setSelectedpolicy(data);
    setFile();
  };

  const handleCloseModal = () => {
    setSelectedpolicy();
    setFile();
  };

  const getDistributorCards = async () => {
    try {
      setLoading(true);
      const distributorCardsData = await fetchAllData(
        `lambdaAPI/OHOCards/GetByMemberId/${Id}`
      );
      setDistributorCards(distributorCardsData);
    } catch (error) {
      console.error("Error fetching Ditributor Card data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddCard = () => {
    setCardNumbers([...cardNumbers, { cardNumber: "2804 00", error: "" }]);
  };

  const handleRemoveCard = (index) => {
    const updatedCardNumbers = cardNumbers.filter((_, i) => i !== index);
    setCardNumbers(updatedCardNumbers);
  };

  const handleChange = (index, value) => {
    const updatedCardNumbers = [...cardNumbers];
    updatedCardNumbers[index].cardNumber = value;
    setCardNumbers(updatedCardNumbers);
  };

  const handleAdd = async () => {
    const updatedCardNumbers = [...cardNumbers];
    let hasError = false;

    updatedCardNumbers.forEach((input, index) => {
      const cardNumber = input.cardNumber.replace(/\s/g, ""); // Remove spaces
      if (cardNumber.length !== 12 || !/^\d{12}$/.test(cardNumber)) {
        updatedCardNumbers[index].error =
          "Card number must be exactly 12 digits.";
        hasError = true;
      } else {
        updatedCardNumbers[index].error = "";
      }
    });

    setCardNumbers(updatedCardNumbers);

    if (hasError) {
      setCardsNumberError("Enter a valid 12-digit Card Number.");
      return;
    }

    try {
      const cardsToAssign = noOfAssigns || updatedCardNumbers.length; // Use noOfAssigns if provided, otherwise use actual count
      const payload = {
        ohoCardNumber: updatedCardNumbers
          .slice(0, cardsToAssign)
          .map((input) => input.cardNumber.trim()),
        noOfAssigns: cardsToAssign,
        rmId: UserId,
        memberId: Id,
      };

      const response = await fetchData(
        "lambdaAPI/OHOCards/AssignCardsToDistributor",
        payload
      );

      setSnackbarMessage(response.message || response.data);
      setSnackbarOpen(true);
      setCardNumbers([{ cardNumber: "2804 00", error: "" }]); // Reset input fields
      setNoOfAssigns(null);

      await getDistributorCards();
    } catch (error) {
      console.error("Error assigning card numbers:", error);
    }
  };

  useEffect(() => {
    getDistributorCards();
  }, []);

  const showIndividualProductView = () => (
    <div className="my-2">
      <h5 className="text-center text-danger fw-semibold">
        {selectedIndividualProduct.PoliciesProductName}
      </h5>

      <SelectNominee
        comboProductId={selectedIndividualProduct.IndividualProductsId}
        selectedProduct={selectedIndividualProduct}
        customerId={customerId}
      />

      <CardEditForms
        selectedProductId={selectedIndividualProduct.IndividualProductsId}
        selectedProduct={selectedIndividualProduct}
      />
    </div>
  );

  const handleProductsBack = () => {
    if (showIndividualProducts) {
      setShowIndividualProducts(false);
    } else {
      setActiveTab("");
    }
  };

  const thresholdDays = 5;

  return (
    <>

      <div className="row justify-content-center mt-2">
        <div className="col-lg-8 col-md-12">
          <div className="card border-0 rounded-4 overflow-hidden">
            <div className="position-relative">

              <div
                className="bg-gradient-primary w-100"
                style={{
                  height: "100px",
                  background: "linear-gradient(135deg, #4158d0 0%, #c850c0 75%, #ffcc70 100%)"
                }}
              ></div>


              <div className="px-4">
                <div className="d-flex flex-wrap align-items-end gap-4">

                  <div className="position-relative mt-n5 mb-2">
                    <div className="rounded-circle p-1 bg-white" style={{ width: "150px", height: "150px" }}>
                      <img
                        src={
                          profile.UserImage
                            ? `${imageUrl}${profile.UserImage}`
                            : profile.Gender && profile.Gender === "Female"
                              ? "../../assets/img/womenlogo.jpg"
                              : "../../assets/img/menlogo.jpg"
                        }
                        className="rounded-circle w-100 h-100"
                        style={{ objectFit: "cover" }}
                        alt="User avatar"
                      />
                    </div>
                  </div>


                  <div className="d-flex flex-column flex-grow-1 mb-2">
                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                      <div>
                        <h2 className="fw-bold mb-1" style={{ color: "#000" }}>
                          {profile.UserName}
                        </h2>

                        <div className="d-flex align-items-center flex-wrap gap-2">
                          {profile.Gender && (
                            <span className="badge bg-info bg-opacity-10  fw-normal px-3 py-2 rounded-pill">
                              <i className="bx bx-user me-1"></i> {profile.Gender}
                            </span>
                          )}
                          {profile.CreatedDate && (
                            <span className="badge bg-light text-secondary fw-normal px-3 py-2 rounded-pill">
                              <i className="bx bx-calendar me-1"></i>
                              Joined {moment(profile.CreatedDate).format("DD MMM YYYY")}
                            </span>
                          )}
                        </div>
                      </div>


                      <div className="d-flex gap-2 mt-2 mt-md-0">
                        {/* <button className="btn btn-primary rounded-pill px-3 py-2 d-flex align-items-center gap-2">
                          <i className="bx bx-user-voice fs-5"></i>
                          <span className="d-none d-sm-inline">Contact</span>
                        </button> */}
                        <button
                          className="btn btn-outline-danger rounded-pill px-3 py-2 d-flex align-items-center gap-2"
                          onClick={handleDelete}
                        >
                          <i className="bx bx-trash-alt fs-5"></i>
                          <span className="d-none d-sm-inline">Delete</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div className="card-body p-4">
              <div className="row">

                <div className="col-md-4">

                  <h5 className="d-flex align-items-center mb-2">
                    <span className="icon-wrapper d-flex align-items-center justify-content-center rounded-circle bg-primary text-white me-3"
                      style={{ width: "38px", height: "38px" }}>
                      <i className="bx bx-phone fs-5"></i>
                    </span>
                    Contact Details
                  </h5>

                  <ul className="list-unstyled mb-0">
                    <li className="pb-3">
                      <div className="d-flex align-items-start">
                        <i className="bx bx-phone-call text-primary fs-4 me-3 mt-1"></i>
                        <div>
                          <div className="text-muted">Mobile Number</div>
                          {profile.MobileNumber ? (
                            <a href={`tel:${profile.MobileNumber}`} className="text-decoration-none fw-semibold fs-5">
                              {profile.MobileNumber}
                            </a>
                          ) : (
                            <span className="text-danger fw-semibold">Not Available</span>
                          )}
                        </div>
                      </div>
                    </li>
                    <li className="pb-3">
                      <div className="d-flex align-items-start">
                        <i className="bx bx-envelope text-primary fs-4 me-3"></i>
                        <div>
                          <div className="text-muted mb-1">Email Address</div>
                          {profile.Email ? (
                            <a href={`mailto:${profile.Email}`} className="text-decoration-none fw-semibold text-break">
                              {profile.Email}
                            </a>
                          ) : (
                            <span className="text-danger fw-semibold">Not Available</span>
                          )}
                        </div>-
                      </div>
                    </li>
                    <li>
                      <div className="d-flex align-items-start">
                        <i className="bx bx-calendar-event text-primary fs-4 me-3 mt-1"></i>
                        <div>
                          <div className="text-muted mb-1">Date of Birth</div>
                          {profile.DateofBirth ? (
                            <span className="fw-semibold">
                              {moment(profile.DateofBirth).format("DD MMM YYYY")}
                            </span>
                          ) : (
                            <span className="text-warning fw-semibold">Not updated</span>
                          )}
                        </div>
                      </div>
                    </li>
                  </ul>

                </div>


                <div className="col-md-4">
                  <h5 className="d-flex align-items-center mb-4">
                    <span
                      className="icon-wrapper d-flex align-items-center justify-content-center rounded-circle bg-primary text-white me-3"
                      style={{ width: "38px", height: "38px" }}
                    >
                      <i className="bx bx-user-check fs-5"></i>
                    </span>
                    Management
                  </h5>

                  <div className="position-relative">
                    {/* RM Name Section */}
                    <div className="d-flex align-items-start mb-3">
                      <i className="bx bx-id-card text-primary fs-4 me-3 mt-1"></i>
                      <div className="w-100">
                        <div className="text-muted mb-1">RM Name</div>
                        <div className="mt-2 d-flex align-items-center gap-2">
                          {!isEditingRM ? (
                            <>
                              <span className="fw-semibold fs-5">
                                {profile.RMName || <span className="text-danger">Not assigned</span>}
                              </span>
                              <button
                                className="btn btn-link btn-sm text-primary p-0 ms-3"
                                onClick={() => {
                                  getRegionalManagers();
                                  setIsEditingRM(true);
                                }}
                              >
                                <i className="bx bx-edit-alt fs-5"></i>
                              </button>
                            </>
                          ) : (
                            <div className="d-flex flex-column w-100 gap-2">
                              <select
                                className="form-select"
                                value={selectedRM}
                                onChange={(e) => setSelectedRM(e.target.value)}
                              >
                                <option value="">Select Regional Manager</option>
                                {rmOptions.map((rm) => (
                                  <option key={rm.value} value={rm.value}>
                                    {rm.label}
                                  </option>
                                ))}
                              </select>
                              <div className="d-flex gap-2 mt-2">
                                <button className="btn btn-success py-2 px-3 flex-grow-1" onClick={handleRMUpdate}>
                                  <i className="bx bx-check me-1"></i> Save
                                </button>
                                <button className="btn btn-outline-secondary py-2 px-3" onClick={() => setIsEditingRM(false)}>
                                  <i className="bx bx-x"></i> Cancel
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Reporting To Section */}
                    <div className="d-flex align-items-start">
                      <i className="bx bx-id-card text-primary fs-4 me-3 mt-1"></i>
                      <div className="w-100">
                        <div className="text-muted mb-1">Reporting To</div>
                        <div className="mt-2 d-flex align-items-center gap-2">
                          {!isEditingReporting ? (
                            <>
                              <span className="fw-semibold fs-5">
                                {profile.ReportingName || <span className="text-danger">Not assigned</span>}
                              </span>
                              <button
                                className="btn btn-link btn-sm text-primary p-0 ms-3"
                                onClick={() => {
                                  getRegionalManagers();
                                  setIsEditingReporting(true);
                                }}
                              >
                                <i className="bx bx-edit-alt fs-5"></i>
                              </button>
                            </>
                          ) : (
                            <div className="d-flex flex-column w-100 gap-2">
                              <select
                                className="form-select"
                                value={selectedReporting}
                                onChange={(e) => setSelectedReporting(e.target.value)}
                              >
                                <option value="">Select Reporting</option>
                                {rmOptions.map((rm) => (
                                  <option key={rm.value} value={rm.value}>
                                    {rm.label}
                                  </option>
                                ))}
                              </select>
                              <div className="d-flex gap-2 mt-2">
                                <button className="btn btn-success py-2 px-3 flex-grow-1" onClick={handleReportingUpdate}>
                                  <i className="bx bx-check me-1"></i> Save
                                </button>
                                <button className="btn btn-outline-secondary py-2 px-3" onClick={() => setIsEditingReporting(false)}>
                                  <i className="bx bx-x"></i> Cancel
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>



                <div className="col-md-4">

                  <div className="d-flex align-items-center justify-content-between">
                    <h5 className="d-flex align-items-center mb-0">
                      <span className="icon-wrapper d-flex align-items-center justify-content-center rounded-circle bg-primary text-white me-3"
                        style={{ width: "38px", height: "38px" }}>
                        <i className="bx bx-map fs-5"></i>
                      </span>
                      Address
                    </h5>

                    {!isEditing && (
                      <span
                        className="text-primary cursor-pointer"
                        onClick={() => {
                          if (!profile) {
                            console.error("Profile data is missing or incomplete.");
                            return;
                          }
                          setAddFormData({
                            AddressLine1: profile.AddressLine1 ?? "",
                            AddressLine2: profile.AddressLine2 ?? "",
                            City: profile.City ?? "",
                            Pincode: profile.Pincode ?? "",
                            Village: profile.Village ?? "",
                            Mandal: profile.Mandal ?? "",
                            StateId: profile.StateId || "",
                            DistrictId: profile.DistrictId || "",
                          });
                          setIsEditing(true);
                        }}
                      >
                        <i className="bx bx-edit-alt me-1"></i>
                      </span>
                    )}

                  </div>

                  <div className="address-content p-4">
                    {profile ? (
                      profile.completeAddress ? (
                        <div className="fw-light lh-lg d-flex flex-row align-items-center flex-wrap">
                          {profile.completeAddress.split(',').map((line, index, arr) => (
                            <React.Fragment key={index}>
                              <span className={`${index === 0 ? 'fw-semibold' : ''}`}>
                                {line.trim()}
                              </span>
                              {index < arr.length - 1 && <span>,&nbsp;</span>}
                            </React.Fragment>
                          ))}
                        </div>
                      ) : (
                        <div className="text-warning d-flex align-items-center">
                          <i className="bx bx-error-circle me-2 fs-4"></i>
                          Address not available
                        </div>
                      )
                    ) : (
                      <div className="text-danger d-flex align-items-center">
                        <i className="bx bx-error-circle me-2 fs-4"></i>
                        Not available
                      </div>
                    )}
                  </div>


                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-4 col-md-12 mt-3 mt-lg-0">
          <div
            className="border-0 rounded-4 overflow-hidden h-100"
            style={{
              background: "rgba(255, 255, 255, 0.95)",
              backdropFilter: "blur(20px)",
              boxShadow: "0 32px 64px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(255, 255, 255, 0.2)",
              border: "1px solid rgba(255, 255, 255, 0.18)"
            }}
          >
            {/* Modern Header */}
            <div
              className="d-flex align-items-center py-4 px-4"
              style={{
                background: "linear-gradient(135deg, rgba(99, 102, 241, 0.1) 0%, rgba(168, 85, 247, 0.1) 100%)",
                borderBottom: "1px solid rgba(99, 102, 241, 0.1)"
              }}
            >
              <div className="d-flex align-items-center">
                <div
                  className="rounded-3 p-2 me-3"
                  style={{
                    background: "linear-gradient(135deg, #6366f1 0%, #a855f7 100%)",
                    boxShadow: "0 8px 16px rgba(99, 102, 241, 0.3)"
                  }}
                >
                  <i className="bi bi-credit-card-2-front-fill text-white" style={{ fontSize: "1.1rem" }}></i>
                </div>
                <div>
                  <h6 className="m-0 fw-bold" style={{ color: "#1f2937", fontSize: "1rem" }}>Card Information</h6>
                  <small style={{ color: "#6b7280", fontSize: "0.8rem" }}>Manage your Health card</small>
                </div>
              </div>
            </div>

            {/* Card Body - Loading State */}
            {cardLoading ? (
              <div className="d-flex flex-column justify-content-center align-items-center py-5">
                <div
                  className="spinner-border mb-3"
                  role="status"
                  style={{
                    color: "#6366f1",
                    width: "2.5rem",
                    height: "2.5rem",
                    borderWidth: "3px"
                  }}
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="text-muted mb-0" style={{ fontSize: "0.95rem" }}>Retrieving card details...</p>
                <div
                  className="progress mt-3"
                  style={{
                    width: '220px',
                    height: '4px',
                    background: "rgba(99, 102, 241, 0.1)"
                  }}
                >
                  <div
                    className="progress-bar progress-bar-striped progress-bar-animated"
                    style={{
                      background: "linear-gradient(90deg, #6366f1, #a855f7)",
                      width: '65%'
                    }}
                  ></div>
                </div>
              </div>
            ) : cardDetails.status && cardDetails.returnData.length > 0 ? (
              <div className="p-3">
                {/* Enhanced 3D Credit Card */}
                <div className="d-flex justify-content-center mb-4">
                  <div
                    style={{
                      width: "300px",
                      height: "190px",
                      perspective: "1000px"
                    }}
                    onMouseEnter={() => setIsFlipped(true)}
                    onMouseLeave={() => setIsFlipped(false)}
                    className="cursor-pointer"
                  >
                    <div
                      style={{
                        position: "relative",
                        width: "100%",
                        height: "100%",
                        transition: "transform 0.6s cubic-bezier(0.23, 1, 0.320, 1)",
                        transformStyle: "preserve-3d",
                        transform: isFlipped ? "rotateY(180deg)" : "rotateY(0deg)",
                      }}
                    >
                      {/* Front Side - Enhanced Modern Design */}
                      <div
                        style={{
                          position: "absolute",
                          width: "100%",
                          height: "100%",
                          backfaceVisibility: "hidden",
                          borderRadius: "12px",
                          overflow: "hidden",
                          //background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                          //boxShadow: "0 25px 50px rgba(102, 126, 234, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.1)"
                        }}
                      >
                        {/* Holographic Overlay */}
                        <div
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: `
                          radial-gradient(circle at 25% 25%, rgba(255, 255, 255, 0.2) 0%, transparent 50%),
                          linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%)
                        `,
                            opacity: 0.6
                          }}
                        />

                        <img
                          src={cardFrontImage}
                          alt="Front side"
                          className="w-100 h-100"
                          style={{
                            objectFit: "cover",
                            mixBlendMode: "overlay",
                            //opacity: 0.3
                          }}
                        />

                        <div
                          className="position-absolute bottom-0 start-0 w-100"
                          style={{ padding: "8px 20px" }}
                        >
                          <p
                            className="text-white m-0 mb-2"
                            style={{
                              fontSize: "1rem",
                              fontFamily: "monospace",
                              letterSpacing: "0.1em",
                              textShadow: "1px 1px 3px rgba(0,0,0,0.6)"
                            }}
                          >
                            {formatCardNumber(cardDetails.returnData[0]?.OHOCardnumber)}
                          </p>

                          {cardDetails.returnData[0].IsActivated === true ? (
                            <span
                              className="badge d-inline-flex align-items-center"
                              style={{
                                background: "rgba(34, 197, 94, 0.9)",
                                backdropFilter: "blur(10px)",
                                padding: "6px 12px",
                                borderRadius: "20px",
                                fontSize: "0.75rem",
                                fontWeight: "500",
                                border: "1px solid rgba(255, 255, 255, 0.2)"
                              }}
                            >
                              <i className="bi bi-check-circle-fill me-2"></i> Active
                            </span>
                          ) : (
                            <span
                              className="badge d-inline-flex align-items-center"
                              style={{
                                background: "rgba(239, 68, 68, 0.9)",
                                backdropFilter: "blur(10px)",
                                padding: "6px 12px",
                                borderRadius: "20px",
                                fontSize: "0.75rem",
                                fontWeight: "500",
                                border: "1px solid rgba(255, 255, 255, 0.2)"
                              }}
                            >
                              <i className="bi bi-x-circle-fill me-2"></i> Inactive
                            </span>
                          )}
                        </div>
                      </div>

                      {/* Back Side - Enhanced Modern Design */}
                      <div
                        style={{
                          position: "absolute",
                          width: "100%",
                          height: "100%",
                          backfaceVisibility: "hidden",
                          transform: "rotateY(180deg)",
                          borderRadius: "12px",
                          overflow: "hidden",
                          //background: "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
                          // boxShadow: "0 25px 50px rgba(118, 75, 162, 0.4)"
                        }}
                      >
                        <img
                          src={cardBackImage}
                          alt="Back side"
                          className="w-100 h-100"
                          style={{
                            objectFit: "cover",
                            mixBlendMode: "overlay",
                            //opacity: 0.4
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="text-center mb-4"
                  style={{ color: "#6b7280" }}
                >
                  <small className="d-flex align-items-center justify-content-center">
                    <i className="bi bi-info-circle me-2"></i>
                    Hover over card to see the reverse side
                  </small>
                </div>

                {/* Modern Action Buttons */}
                <div className="d-flex justify-content-center gap-3">
                  {cardDetails.returnData[0].IsActivated === null || cardDetails.returnData[0].IsActivated === false ? (
                    <button
                      type="button"
                      className="btn d-flex align-items-center px-4 py-2"
                      onClick={() => handleUpdateActivated("Activate")}
                      style={{
                        background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                        border: "none",
                        borderRadius: "12px",
                        color: "white",
                        fontWeight: "500",
                        fontSize: "0.9rem",
                        boxShadow: "0 8px 16px rgba(16, 185, 129, 0.3)",
                        transition: "all 0.3s ease"
                      }}
                      onMouseOver={(e) => e.target.style.transform = "translateY(-2px)"}
                      onMouseOut={(e) => e.target.style.transform = "translateY(0px)"}
                    >
                      <i className="bi bi-check-circle-fill me-2"></i>
                      Activate
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn d-flex align-items-center px-4 py-2"
                      onClick={() => handleUpdateActivated("Deactivate")}
                      style={{
                        background: "rgba(239, 68, 68, 0.1)",
                        border: "2px solid #ef4444",
                        borderRadius: "12px",
                        color: "#ef4444",
                        fontWeight: "500",
                        fontSize: "0.9rem",
                        transition: "all 0.3s ease"
                      }}
                      onMouseOver={(e) => {
                        e.target.style.background = "#ef4444";
                        e.target.style.color = "white";
                      }}
                      onMouseOut={(e) => {
                        e.target.style.background = "rgba(239, 68, 68, 0.1)";
                        e.target.style.color = "#ef4444";
                      }}
                    >
                      <i className="bi bi-x-circle-fill me-2"></i>
                      Deactivate
                    </button>
                  )}

                  <button
                    type="button"
                    className="btn d-flex align-items-center px-4 py-2"
                    onClick={(e) => handleBookService(e)}
                    style={{
                      background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                      border: "none",
                      borderRadius: "12px",
                      color: "white",
                      fontWeight: "500",
                      fontSize: "0.9rem",
                      boxShadow: "0 8px 16px rgba(240, 147, 251, 0.3)",
                      transition: "all 0.3s ease"
                    }}
                    onMouseOver={(e) => e.target.style.transform = "translateY(-2px)"}
                    onMouseOut={(e) => e.target.style.transform = "translateY(0px)"}
                  >
                    <i className="bi bi-calendar-check-fill me-2"></i>
                    Book Service
                  </button>
                </div>
              </div>
            ) : (
              <div className="d-flex flex-column justify-content-center align-items-center py-5">
                <div className="text-center mb-3">
                  <div
                    className="rounded-circle p-4 d-inline-flex mb-3"
                    style={{
                      background: "rgba(239, 68, 68, 0.1)",
                      color: "#ef4444"
                    }}
                  >
                    <i className="bi bi-exclamation-circle" style={{ fontSize: "2rem" }}></i>
                  </div>
                </div>
                <div
                  className="fw-bold text-center mb-2"
                  style={{ color: "#ef4444", fontSize: "1.1rem" }}
                >
                  {cardDetails.message || "No Card Information Available"}
                </div>
                <p
                  className="text-center small mb-0"
                  style={{ color: "#6b7280", maxWidth: "280px" }}
                >
                  The customer does not have a card associated with their account.
                </p>
              </div>
            )}
          </div>
        </div>

      </div>


      {/* Address Edit Modal */}
      {isEditing && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{
            background: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
          }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg rounded-4">

              {/* Modal Header */}
              <div className="modal-header bg-gradient-primary text-white px-4 py-3">
                <h5 className="modal-title fw-semibold">
                  <i className="bx bx-map-pin me-2"></i>
                  Update Address
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setIsEditing(false)}
                ></button>
              </div>

              {/* Modal Body */}
              <div className="modal-body p-4">
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label small fw-semibold">Address Line 1</label>
                    <div className="input-group">
                      <span className="input-group-text bg-light border-0">
                        <i className="bx bx-home text-primary"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control border-0 bg-light"
                        placeholder="Enter address line 1"
                        value={addFormData.AddressLine1 || ""}
                        onChange={(e) => setAddFormData({ ...addFormData, AddressLine1: e.target.value })}
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label small fw-semibold">Address Line 2</label>
                    <div className="input-group">
                      <span className="input-group-text bg-light border-0">
                        <i className="bx bx-building-house text-primary"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control border-0 bg-light"
                        placeholder="Enter address line 2"
                        value={addFormData.AddressLine2 || ""}
                        onChange={(e) => setAddFormData({ ...addFormData, AddressLine2: e.target.value })}
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label small fw-semibold">Pincode</label>
                    <div className="input-group">
                      <span className="input-group-text bg-light border-0">
                        <i className="bx bx-current-location text-primary"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control border-0 bg-light"
                        placeholder="Enter pincode"
                        maxLength={6}
                        value={addFormData.Pincode || ""}
                        onChange={(e) => {
                          const numericValue = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                          setAddFormData({ ...addFormData, Pincode: numericValue });
                        }}
                      />
                    </div>
                  </div>


                  <div className="col-md-6">
                    <label className="form-label small fw-semibold">City</label>
                    <div className="input-group">
                      <span className="input-group-text bg-light border-0">
                        <i className="bx bx-buildings text-primary"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control border-0 bg-light"
                        placeholder="Enter city"
                        value={addFormData.City || ""}
                        onChange={(e) => setAddFormData({ ...addFormData, City: e.target.value })}
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label small fw-semibold">Mandal</label>
                    <div className="input-group">
                      <span className="input-group-text bg-light border-0">
                        <i className="bx bx-buildings text-primary"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control border-0 bg-light"
                        placeholder="Enter Mandal"
                        value={addFormData.Mandal || ""}
                        onChange={(e) => setAddFormData({ ...addFormData, Mandal: e.target.value })}
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label small fw-semibold">Village</label>
                    <div className="input-group">
                      <span className="input-group-text bg-light border-0">
                        <i className="bx bx-buildings text-primary"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control border-0 bg-light"
                        placeholder="Enter Village"
                        value={addFormData.Village || ""}
                        onChange={(e) => setAddFormData({ ...addFormData, Village: e.target.value })}
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label small fw-semibold">State</label>
                    <div className="input-group">
                      <span className="input-group-text bg-light border-0">
                        <i className="bx bx-globe text-primary"></i>
                      </span>
                      <select
                        className="form-select border-0 bg-light"
                        value={addFormData.StateId}
                        onChange={handleStateChange}
                      >
                        <option value="">Select State</option>
                        {stateDropdown.map((state) => (
                          <option key={state.StateId} value={state.StateId}>
                            {state.StateName}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label small fw-semibold">District</label>
                    <div className="input-group">
                      <span className="input-group-text bg-light border-0">
                        <i className="bx bx-map-pin text-primary"></i>
                      </span>
                      <select
                        className="form-select border-0 bg-light"
                        value={addFormData.DistrictId}
                        onChange={handleDistrictChange}
                      >
                        <option value="">Select District</option>
                        {districtDropdown.map((district) => (
                          <option key={district.DistrictId} value={district.DistrictId}>
                            {district.DistrictName}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              {/* Modal Footer */}
              <div className="modal-footer bg-light border-0 d-flex justify-content-between px-4 py-3">
                <button
                  className="btn btn-outline-danger rounded-pill px-4"
                  onClick={() => setIsEditing(false)}
                >
                  <i className="bx bx-x-circle"></i> Cancel
                </button>
                <button
                  className="btn btn-primary rounded-pill px-4 d-flex align-items-center gap-2"
                  onClick={EditAddress}
                >
                  <i className="bx bx-save"></i> Save Changes
                </button>
              </div>

            </div>
          </div>
        </div>
      )}


      {/* <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: { xs: 0.5, sm: 1.5 }, // Reduce spacing between buttons
          padding: 1.5, // Reduce padding
          borderRadius: 3,
          justifyContent: { xs: "center", md: "flex-start" }
        }}
      >
        {[
          { id: "product", label: "Member Products", icon: "bi-box-seam" },
          { id: "call", label: "Call History", icon: "bi-telephone" },
          { id: "cardAssigning", label: "Card Assigning", icon: "bi-card-checklist" }
        ].map((item) => (
          <Button
            key={item.id}
            variant={activeSection === item.id ? "contained" : "outlined"}
            onClick={() => setActiveSection(item.id)}
            sx={{
              borderRadius: 5, // Reduce border radius
              px: { xs: 1.5, sm: 2 }, // Reduce horizontal padding
              py: 0.8, // Reduce vertical padding
              fontSize: "0.85rem", // Reduce font size
              textTransform: "none",
              transition: "all 0.3s ease",
              backgroundColor: activeSection === item.id ? "primary.main" : "transparent",
              borderColor: activeSection === item.id ? "primary.main" : "divider",
              color: activeSection === item.id ? "white" : "text.primary",
              fontWeight: 500,
              "&:hover": {
                backgroundColor: activeSection === item.id ? "primary.dark" : "rgba(0, 0, 0, 0.04)",
                transform: "translateY(-1px)", // Slight hover effect
                boxShadow: activeSection === item.id ? "0 4px 10px rgba(25, 118, 210, 0.2)" : "0 3px 6px rgba(0, 0, 0, 0.05)"
              }
            }}
            startIcon={
              <i className={item.icon} style={{ fontSize: "0.95rem" }}></i> // Reduce icon size
            }
          >
            {item.label}
          </Button>
        ))}
      </Box> */}





      {/* {activeSection === "call" && ( */}

      {/* )} */}

      {/* {activeSection === "product" && ( */}

      {/* )} */}



      <div className="col-md-12 mb-4 mt-5">
        <div className="card border-0 rounded-4 overflow-hidden" style={{ boxShadow: "0 0.5rem 1.5rem rgba(0,0,0,0.15)" }}>
          <div className="card-header border-0 py-4" style={{
            background: "linear-gradient(135deg, #2e7d32 0%, #4caf50 100%)",
            position: "relative"
          }}>
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center">
                {activeTab === "products" && (
                  <button
                    className="btn btn-light rounded-circle me-3 d-flex align-items-center justify-content-center"
                    style={{
                      width: "45px",
                      height: "45px",
                      backgroundColor: "rgba(255,255,255,0.2)",
                      border: "2px solid rgba(255,255,255,0.3)",
                      color: "white",
                      transition: "all 0.3s ease"
                    }}
                    onClick={() => handleProductsBack()}
                    onMouseOver={(e) => {
                      e.target.style.backgroundColor = "rgba(255,255,255,0.9)";
                      e.target.style.color = "#2e7d32";
                      e.target.style.transform = "scale(1.1)";
                    }}
                    onMouseOut={(e) => {
                      e.target.style.backgroundColor = "rgba(255,255,255,0.2)";
                      e.target.style.color = "white";
                      e.target.style.transform = "scale(1)";
                    }}
                  >
                    <i className="bi bi-arrow-left fs-5"></i>
                  </button>
                )}
                <div className="d-flex align-items-center">
                  <div className="rounded-3 p-2 me-3" style={{ backgroundColor: "rgba(255,255,255,0.2)" }}>
                    <i className="bi bi-box-seam text-white fs-5"></i>
                  </div>
                  <div>
                    <h4 className="text-white mb-0 fw-bold">Member Products</h4>
                    <p className="text-white mb-0 small" style={{ opacity: "0.8" }}>Manage your product portfolio</p>
                  </div>
                </div>
              </div>

              {activeTab === "products" && selectedProduct && (
                <button
                  className="btn btn-light d-flex align-items-center gap-2 rounded-pill px-4 py-2 shadow-sm"
                  onClick={handlePrint}
                  style={{
                    transition: "all 0.3s ease",
                    fontWeight: "600"
                  }}
                  onMouseOver={(e) => {
                    e.target.style.transform = "translateY(-2px)";
                    e.target.style.boxShadow = "0 8px 25px rgba(0,0,0,0.15)";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow = "0 0.125rem 0.25rem rgba(0,0,0,0.075)";
                  }}
                >
                  <i className="bi bi-printer text-success"></i>
                  <span>Print Address</span>
                </button>
              )}
            </div>
          </div>

          <div className="card-body" style={{ padding: "2rem" }}>
            <div className="overflow-auto" style={{ maxHeight: "650px" }}>
              {showIndividualProducts ? (
                showIndividualProductView()
              ) : activeTab === "products" && selectedProduct ? (
                <div className="row mb-2">
                  <div className="col-lg-4 mb-4 mb-lg-0">
                    <div className="card border-0 rounded-4 h-100" style={{ boxShadow: "0 0.25rem 1rem rgba(0,0,0,0.1)" }}>
                      <div
                        className="card-header py-3"
                        style={{
                          background: "linear-gradient(135deg, rgba(76, 175, 80, 0.1) 0%, rgba(46, 125, 50, 0.05) 100%)",
                          borderBottom: "2px solid rgba(76, 175, 80, 0.2)"
                        }}
                      >
                        <h6 className="mb-0 fw-bold d-flex align-items-center text-success">
                          <i className="bi bi-info-circle me-2"></i>
                          Product Details
                        </h6>
                      </div>
                      <div className="card-body" style={{ padding: "1.5rem" }}>
                        <div className="mb-4 text-center">
                          <div
                            className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                            style={{
                              width: "60px",
                              height: "60px",
                              background: "linear-gradient(135deg, #2e7d32 0%, #4caf50 100%)",
                              color: "white"
                            }}
                          >
                            <i className="bi bi-box-seam fs-4"></i>
                          </div>
                          <h5 className="fw-bold text-dark">{selectedProduct.ProductName || "N/A"}</h5>
                        </div>

                        <div className="list-group list-group-flush">
                          <div className="list-group-item px-0 d-flex justify-content-between align-items-center py-3 border-0">
                            <span className="fw-semibold d-flex align-items-center" style={{ color: "#666" }}>
                              <i className="bi bi-currency-rupee me-2 text-success"></i>Price
                            </span>
                            <span
                              className="badge fs-6 px-3 py-2 rounded-pill"
                              style={{
                                background: "linear-gradient(135deg, #4caf50 0%, #2e7d32 100%)",
                                color: "white"
                              }}
                            >
                              <i className="bi bi-currency-rupee"></i>{selectedProduct.PaidAmount || "0"}
                            </span>
                          </div>

                          <div className="list-group-item px-0 d-flex justify-content-between align-items-center py-3 border-0">
                            <span className="fw-semibold d-flex align-items-center" style={{ color: "#666" }}>
                              <i className="bi bi-credit-card me-2 text-primary"></i>UTR Number
                            </span>
                            {selectedProduct.UTRNumber && selectedProduct.UTRNumber.length > 0 ? (
                              <span className="fw-semibold text-dark">{selectedProduct.UTRNumber}</span>
                            ) : (
                              <span className="badge bg-danger rounded-pill">Not Available</span>
                            )}
                          </div>

                          {selectedProduct.IssuedOn && selectedProduct.ValidTill && (
                            <div className="list-group-item px-0 d-flex justify-content-between align-items-center py-3 border-0">
                              <span className="fw-semibold d-flex align-items-center" style={{ color: "#666" }}>
                                <i className="bi bi-calendar-check me-2 text-info"></i>Valid Until
                              </span>
                              <span className="fw-semibold text-dark">{formatDate(selectedProduct.ValidTill).slice(0, 11)}</span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {policies && policies.length > 0 && (
                    <div className="col-lg-8">
                      <div className="card border-0 rounded-4 h-100" style={{ boxShadow: "0 0.25rem 1rem rgba(0,0,0,0.1)" }}>
                        <div
                          className="card-header d-flex justify-content-between align-items-center py-3"
                          style={{
                            background: "linear-gradient(135deg, rgba(13, 110, 253, 0.1) 0%, rgba(13, 110, 253, 0.05) 100%)",
                            borderBottom: "2px solid rgba(13, 110, 253, 0.2)"
                          }}
                        >
                          <h6 className="mb-0 fw-bold d-flex align-items-center text-primary">
                            <i className="bi bi-file-earmark-text me-2"></i>
                            Policy Documents
                          </h6>
                          <span
                            className="badge rounded-pill px-3 py-2"
                            style={{
                              background: "linear-gradient(135deg, #0d6efd 0%, #0056b3 100%)",
                              color: "white"
                            }}
                          >
                            {policies.length} Documents
                          </span>
                        </div>
                        <div className="card-body p-0">
                          <div className="table-responsive">
                            <table className="table table-hover align-middle mb-0">
                              <thead style={{ backgroundColor: "#f8f9ff" }}>
                                <tr>
                                  <th className="border-0 py-3 ps-4 text-uppercase text-muted fw-semibold small">Policy Name</th>
                                  <th className="border-0 py-3 text-uppercase text-muted fw-semibold small">Status</th>
                                  <th className="border-0 py-3 text-uppercase text-muted fw-semibold small">COI Number</th>
                                  <th className="border-0 py-3 pe-4 text-uppercase text-muted fw-semibold small text-end">Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                {policies.map((policy) => (
                                  <tr
                                    key={policy.PoliciesId}
                                    style={{
                                      transition: "all 0.2s ease",
                                      borderBottom: "1px solid #f0f0f0"
                                    }}
                                    onMouseOver={(e) => {
                                      e.currentTarget.style.backgroundColor = "#f8f9ff";
                                      e.currentTarget.style.transform = "translateX(4px)";
                                    }}
                                    onMouseOut={(e) => {
                                      e.currentTarget.style.backgroundColor = "";
                                      e.currentTarget.style.transform = "translateX(0)";
                                    }}
                                  >
                                    <td className="py-3 ps-4">
                                      <div className="d-flex align-items-center">
                                        <div
                                          className="rounded-circle d-flex align-items-center justify-content-center me-3"
                                          style={{
                                            width: "45px",
                                            height: "45px",
                                            background: "linear-gradient(135deg, #dc3545 0%, #c82333 100%)",
                                            color: "white"
                                          }}
                                        >
                                          <i className="bi bi-file-earmark-pdf"></i>
                                        </div>
                                        <div>
                                          <a
                                            className="fw-semibold text-primary d-block mb-1 text-decoration-none"
                                            style={{
                                              cursor: "pointer",
                                              transition: "color 0.2s ease"
                                            }}
                                            onClick={() => {
                                              setSelectedIndividualPrdouct(policy);
                                              setShowIndividualProducts(true);
                                            }}
                                            onMouseOver={(e) => {
                                              e.target.style.color = "#0056b3";
                                              e.target.style.textDecoration = "underline";
                                            }}
                                            onMouseOut={(e) => {
                                              e.target.style.color = "#0d6efd";
                                              e.target.style.textDecoration = "none";
                                            }}
                                          >
                                            {policy.PoliciesProductName}
                                          </a>
                                          {policy.IsMembership && (
                                            <span
                                              className="badge rounded-pill"
                                              style={{
                                                background: "linear-gradient(135deg, #17a2b8 0%, #138496 100%)",
                                                color: "white"
                                              }}
                                            >
                                              Membership
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    </td>
                                    <td className="py-3">
                                      {policy.PolicyDocument ? (
                                        <span className="badge bg-success rounded-pill">Available</span>
                                      ) : (
                                        <span className="badge bg-warning rounded-pill">Pending Upload</span>
                                      )}
                                    </td>
                                    <td className="py-3">
                                      {policy.PolicyCOINumber && policy.PolicyCOINumber.length > 0 ? (
                                        <span className="fw-semibold text-dark">{policy.PolicyCOINumber}</span>
                                      ) : (
                                        <span className="text-muted">—</span>
                                      )}
                                    </td>
                                    <td className="py-3 pe-4">
                                      <div className="d-flex justify-content-end gap-2">
                                        {policy.IsMembership ? (
                                          <button
                                            className="btn btn-primary btn-sm rounded-pill px-3"
                                            onClick={handleGenerateMembership}
                                            disabled={gmcLoading}
                                            style={{
                                              transition: "all 0.2s ease"
                                            }}
                                            onMouseOver={(e) => {
                                              if (!gmcLoading) {
                                                e.target.style.transform = "translateY(-1px)";
                                              }
                                            }}
                                            onMouseOut={(e) => {
                                              e.target.style.transform = "translateY(0)";
                                            }}
                                          >
                                            {gmcLoading ? (
                                              <div className="spinner-border spinner-border-sm" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                              </div>
                                            ) : (
                                              <>
                                                <i className="bi bi-arrow-repeat me-1"></i>
                                                Regenerate
                                              </>
                                            )}
                                          </button>
                                        ) : (
                                          <button
                                            className="btn btn-primary btn-sm rounded-pill px-3"
                                            data-bs-toggle="modal"
                                            data-bs-target="#exLargeModal"
                                            onClick={() => handleSelectPolicy(policy)}
                                            style={{
                                              transition: "all 0.2s ease"
                                            }}
                                            onMouseOver={(e) => {
                                              e.target.style.transform = "translateY(-1px)";
                                            }}
                                            onMouseOut={(e) => {
                                              e.target.style.transform = "translateY(0)";
                                            }}
                                          >
                                            <i className="bi bi-upload me-1"></i>
                                            {policy.PolicyDocument ? "Re-Upload" : "Upload"}
                                          </button>
                                        )}

                                        {policy.PolicyDocument && (
                                          <a
                                            href={`${paUrl}${policy.PolicyDocument}`}
                                            className="btn btn-outline-secondary btn-sm rounded-pill"
                                            target="_blank"
                                            download
                                            style={{
                                              transition: "all 0.2s ease"
                                            }}
                                            onMouseOver={(e) => {
                                              e.target.style.transform = "translateY(-1px)";
                                            }}
                                            onMouseOut={(e) => {
                                              e.target.style.transform = "translateY(0)";
                                            }}
                                          >
                                            <i className="bi bi-download"></i>
                                          </a>
                                        )}
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ) : productsLoading ? (
                <div className="d-flex flex-column justify-content-center align-items-center py-5">
                  <div className="spinner-border text-success mb-3" role="status" style={{ width: "3rem", height: "3rem" }}>
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="text-muted mb-0">Loading products...</p>
                </div>
              ) : products && products.length > 0 ? (
                <div className="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-4 mb-2">
                  {products.map((product, index) => (
                    product.ProductName ? (
                      <div key={index} className="col">
                        <div
                          className="card h-100 position-relative overflow-hidden rounded-4"
                          style={{
                            boxShadow: "0 0.25rem 1rem rgba(0,0,0,0.1)",
                            transition: "all 0.3s ease",
                            border: "none"
                          }}
                          onMouseOver={(e) => {
                            e.currentTarget.style.transform = "translateY(-8px)";
                            e.currentTarget.style.boxShadow = "0 1rem 2rem rgba(0,0,0,0.15)";
                          }}
                          onMouseOut={(e) => {
                            e.currentTarget.style.transform = "translateY(0)";
                            e.currentTarget.style.boxShadow = "0 0.25rem 1rem rgba(0,0,0,0.1)";
                          }}
                        >
                          <div
                            className="position-absolute top-0 start-0 h-100"
                            style={{
                              width: "5px",
                              background: "linear-gradient(135deg, #4caf50 0%, #2e7d32 100%)"
                            }}
                          ></div>

                          <div className="position-absolute top-0 end-0 m-3">
                            <span
                              className="badge rounded-pill px-3 py-2 fw-normal"
                              style={{
                                background: product.IsCombo ?
                                  "linear-gradient(135deg, #0d6efd 0%, #0056b3 100%)" :
                                  "linear-gradient(135deg, #ffc107 0%, #e0a800 100%)",
                                color: "white",
                                fontSize: "0.8rem"
                              }}
                            >
                              {product.IsCombo ? "Combo" : "Individual"}
                            </span>
                          </div>

                          <div className="card-body pt-4 pb-3 px-4" style={{ padding: "1.5rem" }}>
                            <h5 className="card-title fw-bold mb-3 pe-5 text-dark">{product.ProductName}</h5>

                            {product.IssuedOn && product.ValidTill && (
                              <div className="d-flex align-items-center mb-3">
                                <div
                                  className="rounded-circle d-flex align-items-center justify-content-center me-3"
                                  style={{
                                    width: "45px",
                                    height: "45px",
                                    backgroundColor: "rgba(76, 175, 80, 0.1)"
                                  }}
                                >
                                  <i className="bi bi-calendar-check text-success"></i>
                                </div>
                                <div>
                                  <small className="text-muted d-block">Valid Until</small>
                                  <strong className="text-dark">{formatDate(product.ValidTill).slice(0, 11)}</strong>
                                </div>
                              </div>
                            )}

                            <div className="mt-3 d-flex align-items-center">
                              <div
                                className="rounded-circle d-flex align-items-center justify-content-center me-3"
                                style={{
                                  width: "45px",
                                  height: "45px",
                                  backgroundColor: "rgba(13, 110, 253, 0.1)"
                                }}
                              >
                                <i className="bi bi-file-earmark-text text-primary"></i>
                              </div>
                              <div className="progress flex-grow-1" style={{ height: "10px" }}>
                                <div
                                  className="progress-bar"
                                  role="progressbar"
                                  style={{
                                    width: "75%",
                                    background: "linear-gradient(135deg, #4caf50 0%, #2e7d32 100%)"
                                  }}
                                  aria-valuenow="75"
                                  aria-valuemin="0"
                                  aria-valuemax="100"
                                ></div>
                              </div>
                            </div>
                          </div>

                          <div className="card-footer bg-white border-0 d-flex justify-content-end py-3 px-4">
                            <button
                              className="btn rounded-pill fw-semibold px-4"
                              onClick={() => handleProductClick(product)}
                              style={{
                                background: "linear-gradient(135deg, #4caf50 0%, #2e7d32 100%)",
                                border: "none",
                                color: "white",
                                transition: "all 0.2s ease"
                              }}
                              onMouseOver={(e) => {
                                e.target.style.transform = "translateY(-2px)";
                              }}
                              onMouseOut={(e) => {
                                e.target.style.transform = "translateY(0)";
                              }}
                            >
                              View Details
                              <i className="bi bi-arrow-right ms-2"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    ) : null
                  ))}
                </div>
              ) : (
                <div className="text-center py-5">
                  <div className="mb-4">
                    <div
                      className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                      style={{
                        width: "100px",
                        height: "100px",
                        background: "linear-gradient(135deg, #2e7d32 0%, #4caf50 100%)",
                        opacity: "0.1"
                      }}
                    >
                      <i className="bi bi-box" style={{ fontSize: "3rem", color: "#1b5e20" }}></i>
                    </div>
                  </div>
                  <h5 className="text-dark mb-3 fw-bold">No Products Available</h5>
                  <p className="text-muted mb-4">You haven't purchased any products yet.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>


      <div className="col-md-12 mb-4 mt-5">
        <div className="card border-0 rounded-4 overflow-hidden" style={{ boxShadow: "0 0.5rem 1.5rem rgba(0,0,0,0.15)" }}>
          {/* Header with gradient background */}
          <div className="card-header border-0 py-4" style={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            position: "relative"
          }}>
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center">
                <div className="rounded-3 p-2 me-3" style={{ backgroundColor: "rgba(255,255,255,0.2)" }}>
                  <i className="bi bi-telephone-fill text-white fs-5"></i>
                </div>
                <div>
                  <h4 className="text-white mb-0 fw-bold">Call History</h4>
                  <p className="text-white mb-0 small" style={{ opacity: "0.7" }}>Track all your important calls</p>
                </div>
              </div>

              <button
                className="btn btn-light d-flex align-items-center gap-2 rounded-pill px-4 py-2 shadow-sm"
                data-bs-toggle="modal"
                data-bs-target="#exLargeModalCallLog"
                style={{
                  transition: "all 0.3s ease",
                  fontWeight: "600"
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = "translateY(-2px)";
                  e.target.style.boxShadow = "0 8px 25px rgba(0,0,0,0.15)";
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow = "0 0.125rem 0.25rem rgba(0,0,0,0.075)";
                }}
              >
                <i className="bi bi-plus-circle-fill text-primary"></i>
                <span>New Call</span>
              </button>
            </div>
          </div>

          <div className="card-body p-0">
            {callHistoryLoading ? (
              <div className="d-flex flex-column justify-content-center align-items-center py-5">
                <div className="spinner-border text-primary mb-3" role="status" style={{ width: "3rem", height: "3rem" }}>
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="text-muted mb-0">Loading call history...</p>
              </div>
            ) : callHistory && callHistory.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-hover mb-0">
                  <thead style={{ backgroundColor: "#f8f9ff" }}>
                    <tr>
                      <th className="border-0 py-3 ps-4 text-uppercase text-muted fw-semibold small">
                        <i className="bi bi-person-fill me-2"></i>Contact Person
                      </th>
                      <th className="border-0 py-3 text-uppercase text-muted fw-semibold small">
                        <i className="bi bi-chat-dots me-2"></i>Response
                      </th>
                      <th className="border-0 py-3 text-uppercase text-muted fw-semibold small">
                        <i className="bi bi-clock me-2"></i>Date & Time
                      </th>
                      <th className="border-0 py-3 pe-4 text-uppercase text-muted fw-semibold small">
                        <i className="bi bi-chat-square-text me-2"></i>Remarks
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {callHistory.map((call, index) => (
                      <tr
                        key={index}
                        className="border-bottom"
                        style={{
                          transition: "all 0.2s ease",
                          borderBottom: "1px solid #f0f0f0 !important"
                        }}
                        onMouseOver={(e) => {
                          e.currentTarget.style.backgroundColor = "#f8f9ff";
                          e.currentTarget.style.transform = "translateX(4px)";
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.backgroundColor = "";
                          e.currentTarget.style.transform = "translateX(0)";
                        }}
                      >
                        <td className="py-3 ps-4">
                          <div className="d-flex align-items-center">
                            <div className="rounded-circle p-2 me-3" style={{ backgroundColor: "rgba(102, 126, 234, 0.1)" }}>
                              <i className="bi bi-person-fill small" style={{ color: "#667eea" }}></i>
                            </div>
                            <div>
                              <span className="fw-semibold text-dark">{call.UserName}</span>
                            </div>
                          </div>
                        </td>
                        <td className="py-3">
                          <span
                            className="badge rounded-pill px-3 py-2 fw-normal"
                            style={{
                              background: "linear-gradient(45deg, #36d1dc, #5b86e5)",
                              color: "white",
                              fontSize: "0.8rem",
                              transition: "all 0.2s ease"
                            }}
                            onMouseOver={(e) => {
                              e.target.style.transform = "scale(1.05)";
                            }}
                            onMouseOut={(e) => {
                              e.target.style.transform = "scale(1)";
                            }}
                          >
                            {call.CallResponseName}
                          </span>
                        </td>
                        <td className="py-3">
                          <div className="d-flex align-items-center text-muted">
                            <i className="bi bi-calendar3 me-2 small"></i>
                            {moment(call.CollectedDate).local().diff(moment(), "days") <= thresholdDays ? (
                              <span className="small">
                                {moment(call.CollectedDate).local().fromNow()}
                              </span>
                            ) : (
                              <span className="small">
                                {moment(call.CollectedDate).local().format("DD-MMM-YYYY h:mm A")}
                              </span>
                            )}
                          </div>
                        </td>
                        <td className="py-3 pe-4">
                          {call.CallLog && call.CallLog.trim() !== "" ? (
                            <div
                              className="text-truncate bg-light rounded-pill px-3 py-1"
                              style={{
                                maxWidth: "250px",
                                fontSize: "0.85rem",
                                color: "#6c757d"
                              }}
                              title={call.CallLog}
                            >
                              <i className="bi bi-chat-left-text me-2 small"></i>
                              {call.CallLog}
                            </div>
                          ) : (
                            <span className="text-muted small fst-italic">
                              <i className="bi bi-dash-circle me-2"></i>
                              No remarks
                            </span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center py-5">
                <div className="mb-4">
                  <div
                    className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                    style={{
                      width: "80px",
                      height: "80px",
                      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                      opacity: "0.1"
                    }}
                  >
                    <i className="bi bi-telephone" style={{ fontSize: "2rem", color: "#040000dd" }}></i>
                  </div>
                </div>
                <h5 className="text-dark mb-2 fw-bold">No Call History Yet</h5>
                <p className="text-muted mb-4">Start tracking your calls by adding your first call record</p>
                <button
                  className="btn btn-primary rounded-pill px-4 py-2 shadow-sm d-inline-flex align-items-center gap-2"
                  data-bs-toggle="modal"
                  data-bs-target="#exLargeModalCallLog"
                  style={{
                    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    border: "none",
                    fontWeight: "600",
                    transition: "all 0.3s ease"
                  }}
                  onMouseOver={(e) => {
                    e.target.style.transform = "translateY(-1px)";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.transform = "translateY(0)";
                  }}
                >
                  <i className="bi bi-plus-circle-fill"></i>
                  <span>Add Your First Call</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* {activeSection === "cardAssigning" && ( */}
      <div className="container-fluid p-0">
        {/* Card Assignment Section - Modern Design */}
        <div className="card shadow-lg mb-4 border-0 overflow-hidden" style={{ borderRadius: '16px' }}>
          <div className="card-header text-dark py-4 border-0 position-relative"
            style={{
              backgroundImage: 'linear-gradient(135deg, #141e30 0%, #243b55 100%)',
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat'
            }}>
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <div className="bg-white bg-opacity-20 rounded-circle p-2 me-3">
                  <i className="bi bi-credit-card-fill fs-4"></i>
                </div>
                <div>
                  <h4 className="fw-bold mb-1 text-white">Assign Cards</h4>
                  <p className="mb-0 text-white" style={{ opacity: '0.9' }}>Manage and distribute advisor cards</p>
                </div>
              </div>
              <div className="bg-white bg-opacity-20 rounded-pill px-3 py-1">
                <small className="fw-semibold">Active</small>
              </div>
            </div>
            {/* Decorative Elements */}
            {/* <div className="position-absolute top-0 end-0" style={{ opacity: '0.1' }}>
              <i className="bi bi-geo-alt-fill" style={{ fontSize: '120px', transform: 'rotate(15deg)' }}></i>
            </div> */}
          </div>

          <div className="card-body p-4" style={{ background: 'linear-gradient(180deg, #f8f9ff 0%, #ffffff 100%)' }}>
            <div className="row g-4">
              {/* Number of Cards Input - Enhanced */}
              <div className="col-12 col-md-6 col-lg-4">
                <div className="form-group">
                  <label htmlFor="noOfAssigns" className="form-label fw-bold mb-3 text-dark d-flex align-items-center">
                    <i className="bi bi-hash text-primary me-2"></i>
                    Number of Cards
                  </label>
                  <div className="position-relative">
                    <input
                      type="number"
                      id="noOfAssigns"
                      className="form-control form-control-lg border-2 shadow-sm"
                      style={{
                        borderRadius: '12px',
                        paddingLeft: '3rem',
                        background: 'rgba(102, 126, 234, 0.05)',
                        border: '2px solid #e3e7fc'
                      }}
                      value={noOfAssigns || ""}
                      onChange={(e) => setNoOfAssigns(parseInt(e.target.value) || null)}
                      min={1}
                      placeholder="Enter count..."
                    />
                    <div className="position-absolute start-0 top-50 translate-middle-y ps-3">
                      <i className="bi bi-stack text-muted"></i>
                    </div>
                  </div>
                </div>
              </div>

              {/* Card Number Inputs - Modern Grid */}
              <div className="col-12 mt-4">
                <div className="d-flex align-items-center mb-3">
                  <i className="bi bi-credit-card text-primary me-2"></i>
                  <h6 className="fw-bold mb-0 text-dark">Card Numbers</h6>
                  {cardNumbers.length > 0 && (
                    <span className="badge bg-light text-primary ms-2 rounded-pill">
                      {cardNumbers.length} cards
                    </span>
                  )}
                </div>

                <div className="row g-3">
                  {cardNumbers.map((card, index) => (
                    <div className="col-12 col-md-6 col-lg-4" key={index}>
                      <div className="card border-0 shadow-sm h-100" style={{ borderRadius: '12px' }}>
                        <div className="card-body p-3">
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <small className="text-muted fw-semibold">Card #{index + 1}</small>
                            <button
                              className="btn btn-sm btn-outline-danger rounded-circle p-2 border-2"
                              type="button"
                              onClick={() => handleRemoveCard(index)}
                              style={{ width: '32px', height: '32px' }}
                            >
                              <i className="bi bi-x" style={{ fontSize: '14px' }}></i>
                            </button>
                          </div>
                          <Cleave
                            type="tel"
                            className="form-control border-2 shadow-sm"
                            style={{
                              borderRadius: '8px',
                              fontFamily: 'monospace',
                              fontSize: '14px',
                              fontWeight: '600',
                              letterSpacing: '1px',
                              background: '#f8f9ff'
                            }}
                            placeholder="0000 0000 0000"
                            maxLength={14}
                            onChange={(e) => handleChange(index, e.target.value)}
                            value={card.cardNumber}
                            options={{ blocks: [4, 4, 4], delimiter: " " }}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Action Buttons - Modern Style */}
              <div className="col-12 mt-5">
                <div className="d-flex flex-wrap gap-3 align-items-center">
                  <button
                    className="btn btn-outline-primary btn-lg px-5 py-3 border-2 fw-semibold"
                    style={{ borderRadius: '12px' }}
                    onClick={handleAddCard}
                  >
                    <i className="bi bi-plus-lg me-2"></i>
                    Add New Card
                  </button>
                  <button
                    className="btn btn-primary btn-lg px-5 py-3 fw-semibold shadow-lg"
                    style={{
                      borderRadius: '12px',
                      backgroundImage: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      border: 'none'
                    }}
                    onClick={handleAdd}
                    disabled={cardNumbers.length === 0}
                  >
                    <i className="bi bi-rocket-takeoff me-2"></i>
                    Assign All Cards
                  </button>
                  {cardNumbers.length > 0 && (
                    <div className="ms-auto d-flex align-items-center text-muted">
                      <i className="bi bi-info-circle me-2"></i>
                      <small className="fw-semibold">Ready to assign {cardNumbers.length} cards</small>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Advisor Cards Display Section - Modern Table Design */}
        {distributorCards && distributorCards.length > 0 && (
          <div className="card shadow-lg mb-4 border-0 overflow-hidden" style={{
            boxShadow: '0 15px 30px rgba(0, 0, 0, 0.08), 0 2px 4px rgba(0, 0, 0, 0.04)',
            background: 'linear-gradient(145deg, #ffffff 0%, #f9fafb 100%)'
          }}>
            {/* Card Header */}
            <div className="card-header py-3 py-md-4 border-0 position-relative" style={{
              background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
              padding: 'clamp(16px, 3vw, 24px)'
            }}>
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-center text-white gap-2 gap-md-3">
                <div className="d-flex align-items-center gap-2 gap-md-3">
                  <div className="bg-white bg-opacity-25 rounded-circle p-2" style={{
                    width: 'clamp(36px, 6vw, 48px)',
                    height: 'clamp(36px, 6vw, 48px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                  }}>
                    <i className="bi bi-people-fill" style={{ fontSize: 'clamp(1rem, 2.5vw, 1.5rem)', color: '#1e293b' }}></i>
                  </div>
                  <div>
                    <h4 className="fw-bold mb-1" style={{
                      fontSize: 'clamp(1.2rem, 3vw, 1.5rem)',
                      textShadow: '0 1px 2px rgba(0, 0, 0, 0.1)'
                    }}>
                      Advisor Cards
                    </h4>
                    <p className="mb-0" style={{
                      fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
                      opacity: '0.9'
                    }}>
                      Complete card assignment overview
                    </p>
                  </div>
                </div>
                <div className="bg-white bg-opacity-25 rounded-pill px-3 px-md-4 py-2 d-flex align-items-center" style={{
                  boxShadow: '0 3px 8px rgba(0, 0, 0, 0.1)',
                  transition: 'all 0.3s ease'
                }}
                  onMouseOver={(e) => {
                    e.target.style.background = 'rgba(255, 255, 255, 0.35)';
                    e.target.style.transform = 'translateY(-2px)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.background = 'rgba(255, 255, 255, 0.25)';
                    e.target.style.transform = 'translateY(0)';
                  }}>
                  <i className="bi bi-database-fill me-1 me-md-2 text-dark" style={{ fontSize: 'clamp(0.9rem, 2vw, 1rem)' }}></i>
                  <span className="fw-semibold" style={{ fontSize: 'clamp(0.8rem, 2vw, 0.9rem)', color: '#1e293b' }}>
                    {distributorCards.length} Total Cards
                  </span>
                </div>
              </div>
              {/* Decorative Wave */}
              <div className="position-absolute bottom-0 start-0 w-100 overflow-hidden" style={{ height: 'clamp(16px, 2vw, 20px)' }}>
                <svg viewBox="0 0 1200 120" preserveAspectRatio="none" style={{ width: '100%', height: '100%' }}>
                  <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" style={{ fill: 'white', opacity: '0.25' }}></path>
                  <path d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z" style={{ fill: 'white', opacity: '0.5' }}></path>
                  <path d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z" style={{ fill: 'white' }}></path>
                </svg>
              </div>
            </div>

            {/* Card Body */}
            <div className="card-body p-0">
              {loading ? (
                <div className="d-flex flex-column justify-content-center align-items-center p-4 p-md-5" style={{ minHeight: 'clamp(150px, 30vw, 200px)' }}>
                  <div className="spinner-border" style={{
                    width: 'clamp(32px, 5vw, 40px)',
                    height: 'clamp(32px, 5vw, 40px)',
                    borderWidth: 'clamp(3px, 0.8vw, 4px)',
                    color: '#4facfe'
                  }} role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="mt-2 mt-md-3 text-muted fw-semibold" style={{ fontSize: 'clamp(0.9rem, 2vw, 1rem)' }}>
                    Loading cards...
                  </p>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-hover mb-0 align-middle" style={{ fontSize: 'clamp(0.8rem, 1.8vw, 0.9rem)' }}>
                    <thead style={{ background: 'linear-gradient(90deg, #f8f9ff 0%, #e3e7fc 100%)' }}>
                      <tr>
                        {[
                          { label: "CARD ID", icon: "bi bi-hash" },
                          { label: "CARD NUMBER", icon: "bi bi-credit-card" },
                          { label: "ASSIGNED DATE", icon: "bi bi-calendar-plus" },
                          { label: "STATUS", icon: "bi bi-circle-fill" },
                          { label: "SOLD DATE", icon: "bi bi-calendar-check" },
                          { label: "USER NAME", icon: "bi bi-person" },
                          { label: "ADVISOR NAME", icon: "bi bi-person-badge" },
                          { label: "SOLD TO", icon: "fa-solid fa-handshake" }
                        ].map((header) => (
                          <th key={header.label} className="py-3 py-md-4 fw-bold text-dark border-0" style={{
                            fontSize: 'clamp(0.75rem, 1.8vw, 0.85rem)',
                            letterSpacing: '0.5px'
                          }}>
                            <div className="d-flex align-items-center">
                              <i className={`${header.icon} text-primary me-1 me-md-2`} style={{ fontSize: 'clamp(0.75rem, 1.8vw, 0.85rem)' }}></i>
                              <span>{header.label}</span>
                            </div>
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {distributorCards.map((distributorCard, index) => (
                        <tr key={index} className="border-0" style={{
                          borderBottom: '1px solid rgba(0,0,0,0.04)',
                          transition: 'background 0.3s ease'
                        }}
                          onMouseOver={(e) => e.currentTarget.style.background = 'rgba(79, 172, 254, 0.05)'}
                          onMouseOut={(e) => e.currentTarget.style.background = 'transparent'}>
                          <td className="py-3 py-md-4">
                            <div className="d-flex align-items-center">
                              <div className="bg-primary bg-opacity-10 rounded-circle p-2 me-2" style={{
                                width: 'clamp(28px, 5vw, 32px)',
                                height: 'clamp(28px, 5vw, 32px)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}>
                                <small className="fw-bold text-dark">{index + 1}</small>
                              </div>
                              <span className="fw-semibold text-dark">{distributorCard.OHOCardsId}</span>
                            </div>
                          </td>
                          <td className="py-3 py-md-4">
                            <code className="bg-light px-2 px-md-3 py-1 py-md-2 rounded-pill fw-bold text-dark border" style={{
                              fontSize: 'clamp(0.75rem, 1.8vw, 0.85rem)',
                              letterSpacing: '0.8px'
                            }}>
                              {distributorCard.OHOCardNumber}
                            </code>
                          </td>
                          <td className="py-3 py-md-4">
                            <div className="d-flex align-items-center">
                              <i className="bi bi-calendar text-muted me-1 me-md-2" style={{ fontSize: 'clamp(0.75rem, 1.8vw, 0.85rem)' }}></i>
                              <span className="fw-semibold text-dark">
                                {distributorCard.AssignedTOMemberDate
                                  ? formatDate1(distributorCard.AssignedTOMemberDate)
                                  : <span className="text-muted">Not assigned</span>}
                              </span>
                            </div>
                          </td>
                          <td className="py-3 py-md-4">
                            <div className="d-flex align-items-center">
                              {/* <div className={`rounded-circle me-2 ${distributorCard.IsCardSold ? 'bg-success' : 'bg-danger'}`} style={{
                                width: 'clamp(6px, 1vw, 8px)',
                                height: 'clamp(6px, 1vw, 8px)'
                              }}></div> */}
                              <span className={`badge rounded-pill px-2 px-md-3 py-1 py-md-2 fw-semibold ${distributorCard.IsCardSold
                                ? 'bg-success bg-opacity-10 text-dark border border-success border-opacity-25'
                                : 'bg-danger bg-opacity-10 text-dark border border-danger border-opacity-25'
                                }`} style={{ fontSize: 'clamp(0.7rem, 1.8vw, 0.8rem)' }}>
                                {distributorCard.IsCardSold ? (
                                  <><i className="bi bi-check-lg me-1"></i>Sold</>
                                ) : (
                                  <><i className="bi bi-clock me-1"></i>Available</>
                                )}
                              </span>
                            </div>
                          </td>
                          <td className="py-3 py-md-4">
                            <div className="d-flex align-items-center">
                              <i className="bi bi-calendar-check text-muted me-1 me-md-2" style={{ fontSize: 'clamp(0.75rem, 1.8vw, 0.85rem)' }}></i>
                              <span className="fw-semibold text-dark">
                                {distributorCard.CardSoldDate
                                  ? formatDate1(distributorCard.CardSoldDate)
                                  : <span className="text-muted">-</span>}
                              </span>
                            </div>
                          </td>

                          <td className="py-3 py-md-4">
                            <div className="d-flex align-items-center">
                              <div className="bg-info bg-opacity-10 rounded-circle p-2 me-2" style={{
                                width: 'clamp(28px, 5vw, 32px)',
                                height: 'clamp(28px, 5vw, 32px)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}>
                                <i className="bi bi-person text-dark" style={{ fontSize: 'clamp(0.75rem, 1.8vw, 0.85rem)' }}></i>
                              </div>
                              <span className="fw-semibold text-dark">{distributorCard.UserName}</span>
                            </div>
                          </td>
                          <td className="py-3 py-md-4">
                            <div className="d-flex align-items-center">
                              <div className="bg-warning bg-opacity-10 rounded-circle p-2 me-2" style={{
                                width: 'clamp(28px, 5vw, 32px)',
                                height: 'clamp(28px, 5vw, 32px)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}>
                                <i className="bi bi-person-badge text-dark" style={{ fontSize: 'clamp(0.75rem, 1.8vw, 0.85rem)' }}></i>
                              </div>
                              <span className="fw-semibold text-dark">{distributorCard.DistributorName}</span>
                            </div>
                          </td>
                          <td className="py-3 py-md-4">
                            <div className="d-flex align-items-center">
                              {distributorCard.SoldTo ? (
                                <>
                                  <div className="bg-success bg-opacity-10 rounded-circle p-2 me-2" style={{
                                    width: 'clamp(28px, 5vw, 32px)',
                                    height: 'clamp(28px, 5vw, 32px)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                  }}>
                                    <i className="fa-solid fa-handshake text-dark" style={{ fontSize: 'clamp(0.75rem, 1.8vw, 0.85rem)' }}></i>
                                  </div>
                                  <span className="fw-semibold text-dark">{distributorCard.SoldTo}</span>
                                </>
                              ) : (
                                <span className="text-muted fst-italic">Not sold yet</span>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            {/* Card Footer */}
            <div className="card-footer bg-light bg-opacity-50 border-0 py-3 py-md-4" style={{ padding: 'clamp(12px, 2.5vw, 16px)' }}>
              <div className="row g-2 g-md-3 text-center">
                {[
                  { label: 'Total Cards', value: distributorCards.length, color: '#4facfe' },
                  { label: 'Cards Sold', value: distributorCards.filter(card => card.IsCardSold).length, color: '#10b981' },
                  { label: 'Available', value: distributorCards.filter(card => !card.IsCardSold).length, color: '#f59e0b' },
                  { label: 'Success Rate', value: `${Math.round((distributorCards.filter(card => card.IsCardSold).length / distributorCards.length) * 100) || 0}%`, color: '#3b82f6' }
                ].map((stat, index) => (
                  <div key={index} className="col-6 col-md-3">
                    <div className="d-flex flex-column" style={{
                      background: `rgba(${parseInt(stat.color.slice(1, 3), 16), parseInt(stat.color.slice(3, 5), 16), parseInt(stat.color.slice(5, 7), 16)}, 0.05)`,
                      padding: 'clamp(8px, 2vw, 12px)',
                      borderRadius: '8px',
                      transition: 'all 0.3s ease'
                    }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.background = `rgba(${parseInt(stat.color.slice(1, 3), 16), parseInt(stat.color.slice(3, 5), 16), parseInt(stat.color.slice(5, 7), 16)}, 0.1)`;
                        e.currentTarget.style.transform = 'translateY(-2px)';
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.background = `rgba(${parseInt(stat.color.slice(1, 3), 16), parseInt(stat.color.slice(3, 5), 16), parseInt(stat.color.slice(5, 7), 16)}, 0.05)`;
                        e.currentTarget.style.transform = 'translateY(0)';
                      }}>
                      <span className="fw-bold" style={{
                        color: stat.color,
                        fontSize: 'clamp(1.2rem, 3vw, 1.5rem)'
                      }}>{stat.value}</span>
                      <small className="text-muted fw-semibold" style={{ fontSize: 'clamp(0.7rem, 1.8vw, 0.8rem)' }}>{stat.label}</small>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        <style jsx>{`
  .table-responsive {
    max-height: clamp(300px, 60vh, 500px);
    overflow-y: auto;
  }

  .table th, .table td {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
   
  }

  .table tr:hover {
    transition: background 0.3s ease;
  }

  .card {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .card:hover {
    transform: translateY(-2px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1), 0 3px 6px rgba(0, 0, 0, 0.05);
  }

  @media (max-width: 576px) {
    .table-responsive {
      font-size: clamp(0.7rem, 1.6vw, 0.8rem);
    }

    .table th, .table td {
      max-width: clamp(80px, 15vw, 120px);
      padding: clamp(8px, 2vw, 12px) !important;
    }

    .card-header {
      padding: clamp(12px, 2.5vw, 16px) !important;
    }
  }

  @media (min-width: 577px) and (max-width: 992px) {
    .table-responsive {
      font-size: clamp(0.75rem, 1.8vw, 0.85rem);
    }
  }

  @media (min-resolution: 2dppx) {
    .card, .badge, .rounded-circle {
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
    }
  }
`}</style>
      </div >
      {/* )} */}


      <div
        className="modal fade"
        id="exLargeModalCallLog"
        tabIndex="-1"
        aria-hidden="true"
        aria-labelledby="exampleModalLabel4"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalLabel4">
                Add Call History
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <form onSubmit={onSubmitHandler} className="p-4">
              <div className="mb-4">
                <h5 className="mb-3" style={{ fontWeight: "bold" }}>
                  Call Response{" "}
                  <span className="required" style={{ color: "red" }}>
                    {" "}
                    *
                  </span>
                </h5>

                <div className="d-flex flex-wrap">
                  {callResponseOptions.map((option) => (
                    <div
                      className="form-check me-4 mb-2 col-5"
                      key={option.CallResponsesId}
                    >
                      <input
                        className="form-check-input"
                        type="radio"
                        id={`callResponse_${option.CallResponsesId}`}
                        name="callResponsesId"
                        value={option.CallResponsesId}
                        checked={formData.callResponsesId.includes(
                          option.CallResponsesId
                        )}
                        onChange={onChangeHandler}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`callResponse_${option.CallResponsesId}`}
                      >
                        {option.ResponseName}
                      </label>
                    </div>
                  ))}
                </div>
              </div>

              <div className="row">
                <div className="col-12 col-sm-6">
                  <div className="mb-3">
                    <label htmlFor="DateToBeVisited" className="form-label">
                      Date To Be Visited
                    </label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      id="DateToBeVisited"
                      name="DateToBeVisited"
                      placeholder="YYYY-MM-DD HH:MM"
                      value={formData.DateToBeVisited}
                      onChange={onChangeHandler}
                    />
                  </div>
                </div>

                <div className="col-12 col-sm-6">
                  <div className="mb-3">
                    <label htmlFor="RequestCallBack" className="form-label">
                      Request Call Back
                    </label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      id="RequestCallBack"
                      name="RequestCallBack"
                      placeholder="YYYY-MM-DD HH:MM"
                      value={formData.RequestCallBack}
                      onChange={onChangeHandler}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label htmlFor="remarks" className="form-label">
                      Remarks
                    </label>
                    <textarea
                      className="form-control"
                      id="remarks"
                      name="callLog"
                      placeholder="Enter Remarks"
                      onChange={onChangeHandler}
                      value={formData.callLog}
                      rows="4"
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 d-flex justify-content-center">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={!isFormValid}
                  >
                    {isEditing ? "Update" : "Submit"}
                  </button>
                  <button
                    className="btn btn-secondary ms-2"
                    type="button"
                    onClick={handleResetForm}
                  >
                    Reset
                  </button>
                  <button
                    className="btn btn-danger ms-2"
                    type="button"
                    onClick={handleBackToView}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="exLargeModalPurchase"
        tabIndex="-1"
        aria-hidden="true"
        aria-labelledby="exampleModalLabel4"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalLabel4">
                Product Purchase
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            {purchaseProduct ? (
              <>
                {purchaseProduct ? (
                  <>
                    {/* OHO Card Number Input Card */}
                    {purchaseProduct.IsCombo === true && !cardNumberEntered && (
                      <div className="card p-3" style={{ minWidth: "400px" }}>
                        <label
                          className="form-label"
                          htmlFor="cardNumber"
                          style={{ fontSize: "15px" }}
                        >
                          Card Number <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          id="cardNumber"
                          className="form-control"
                          placeholder="2804 0000 0001"
                          value={cardNumber}
                          onChange={handleCardNumberChange}
                          maxLength={14}
                        />
                        {cardNumberError && (
                          <p className="text-danger">{cardNumberError}</p>
                        )}
                        <button
                          className="btn btn-primary mt-3"
                          onClick={checkCardNumberExists} // Check if card number exists on click
                        >
                          Confirm Card Number
                        </button>
                      </div>
                    )}

                    {/* Main Product Details Card */}
                    {(!purchaseProduct.IsCombo || cardNumberEntered) && (
                      <div className="card p-3 d-flex flex-column align-items-center">
                        <h5 className="card-header">
                          <strong>Product Name: </strong>
                          <span className="text-primary fs-4 fw-bold">
                            {purchaseProduct.ProductName}
                          </span>
                        </h5>

                        {!purchaseProduct.IsFree && (
                          <img
                            src="https://ohoindia-mous.s3.ap-south-1.amazonaws.com/70ec0ebd-a761-4dc4-acb8-80750653a421.jpg"
                            alt="QR Code"
                            className="h-25 w-25 mt-3 mb-3"
                          />
                        )}
                        <p className="fs-5">
                          Amount to pay:
                          <FontAwesomeIcon
                            icon={faIndianRupeeSign}
                            className="text-primary"
                          />{" "}
                          <span>
                            {purchaseProduct.IsFree ? (
                              <>
                                <span
                                  style={{
                                    textDecoration: "line-through",
                                    color: "#349bc7",
                                  }}
                                >
                                  {
                                    purchaseProduct.InsurancePremiums[0]
                                      .TotalAmount
                                  }
                                </span>{" "}
                                Free
                              </>
                            ) : (
                              purchaseProduct.InsurancePremiums[0].TotalAmount
                            )}
                          </span>
                        </p>

                        {/* If product is free, skip UTR input and directly proceed with purchase */}
                        {purchaseProduct.IsFree ? (
                          <div className="mt-3 d-flex flex-row justify-content-center">
                            <button
                              type="submit"
                              className="btn btn-primary me-sm-3 me-1"
                              onClick={(e) => submitUtrForm(e)} // Submit directly
                              disabled={utrSubmitLoad}
                            >
                              {utrSubmitLoad ? (
                                <div
                                  className="spinner-border text-white"
                                  role="status"
                                >
                                  <span className="sr-only">Loading...</span>
                                </div>
                              ) : (
                                "Submit"
                              )}
                            </button>
                            <button
                              type="button"
                              className="btn btn-label-secondary"
                              onClick={() => setPurchaseProduct()}
                            >
                              Cancel
                            </button>
                          </div>
                        ) : (
                          <>
                            {/* UTR Number Input */}
                            <div style={{ minWidth: "400px" }}>
                              <label
                                className="form-label"
                                htmlFor="utrnumber"
                                style={{ fontSize: "15px" }}
                              >
                                UTR Number{" "}
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                id="utrnumber"
                                className="form-control"
                                placeholder="Enter UTR Number"
                                value={utrNumber}
                                onChange={(e) => onChangeUtrNumber(e)}
                              />
                              {utrError && (
                                <p className="text-danger">
                                  *Please Enter UTR Number
                                </p>
                              )}
                            </div>

                            {/* Submit Button */}
                            <div className="mt-3 d-flex flex-row justify-content-center">
                              <button
                                type="submit"
                                className="btn btn-primary me-sm-3 me-1"
                                onClick={(e) => submitUtrForm(e)}
                                style={{ minWidth: "100px" }}
                                disabled={utrSubmitLoad}
                              >
                                {utrSubmitLoad ? (
                                  <div
                                    className="spinner-border text-white"
                                    role="status"
                                  >
                                    <span className="sr-only">Loading...</span>
                                  </div>
                                ) : (
                                  "Submit"
                                )}
                              </button>
                              <button
                                type="button"
                                className="btn btn-label-secondary"
                                onClick={() => setPurchaseProduct()}
                              >
                                Cancel
                              </button>
                            </div>
                          </>
                        )}

                        {paymentSuccessMsg && (
                          <p className="text-success mt-3">
                            Successfully purchased product
                          </p>
                        )}
                        {memberPrdAddFail && memberPrdAddFail.length > 0 && (
                          <p className="text-danger mt-3">{memberPrdAddFail}</p>
                        )}
                        {paymentFailureError &&
                          paymentFailureError.length > 0 && (
                            <p className="text-danger mt-3">
                              {paymentFailureError}
                            </p>
                          )}
                        {updatePaymentForProductError &&
                          updatePaymentForProductError.length > 0 && (
                            <p className="text-danger mt-3">
                              {updatePaymentForProductError}
                            </p>
                          )}
                        {cardAddError && cardAddError.length > 0 && (
                          <p className="text-danger mt-3">{cardAddError}</p>
                        )}
                      </div>
                    )}
                  </>
                ) : availableProducts && availableProducts.length > 0 ? (
                  <div className="container-fluid">
                    <div className="row">
                      {availableProducts.map((product) => (
                        <div
                          key={product.ProductsId}
                          className="card d-flex flex-column col-md-5 p-3 mt-2 mb-2 me-3"
                        >
                          <div className="d-flex flex-row align-items-center">
                            <i
                              className="fa-solid fa-circle-check me-2"
                              style={{ color: "#349bc7" }}
                            ></i>
                            <h5 className="mb-1 text-dark">
                              {product.ProductName}
                            </h5>
                          </div>
                          <p
                            className="text-secondary"
                            style={{ fontSize: "14px" }}
                          >
                            {product.ProductCategoryName}
                          </p>

                          <div className="d-flex flex-row align-items-center">
                            <h6>Amount: </h6>
                            <p className="ms-1">
                              {product.IsFree ? (
                                <>
                                  <span
                                    style={{
                                      textDecoration: "line-through",
                                      color: "#349bc7",
                                    }}
                                  >
                                    <i
                                      className="fa-solid fa-indian-rupee-sign"
                                      style={{ color: "#349bc7" }}
                                    ></i>{" "}
                                    {product.InsurancePremiums[0].TotalAmount}
                                  </span>{" "}
                                  Free
                                </>
                              ) : (
                                <>
                                  <i
                                    className="fa-solid fa-indian-rupee-sign"
                                    style={{ color: "#349bc7" }}
                                  ></i>{" "}
                                  {product.InsurancePremiums[0].TotalAmount}
                                </>
                              )}
                            </p>
                          </div>

                          <button
                            className="btn btn-primary align-self-end"
                            onClick={() => setPurchaseProduct(product)}
                          >
                            Purchase
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div>
                    <h5 className="text-danger fw-semibold text-center">
                      No Products Available
                    </h5>
                  </div>
                )}
              </>
            ) : availableProducts && availableProducts.length > 0 ? (
              <div className="container-fluid">
                <div className="row">
                  {availableProducts.map((product) => (
                    <div
                      key={product.ProductsId}
                      className="card d-flex flex-column col-md-5 p-3 mt-2 mb-2 me-3"
                    >
                      <div className="d-flex flex-row align-items-center">
                        <i
                          className="fa-solid fa-circle-check me-2"
                          style={{ color: "#349bc7" }}
                        ></i>
                        <h5 className="mb-1 text-dark">
                          {product.ProductName}
                        </h5>
                      </div>

                      <div className="d-flex flex-row align-items-center">
                        <h6>Amount: </h6>
                        <p className="ms-1">
                          {product.IsFree ? (
                            <>
                              <span
                                style={{
                                  textDecoration: "line-through",
                                  color: "#349bc7",
                                }}
                              >
                                <i
                                  className="fa-solid fa-indian-rupee-sign"
                                  style={{ color: "#349bc7" }}
                                ></i>{" "}
                                {product.InsurancePremiums[0].TotalAmount}
                              </span>{" "}
                              Free
                            </>
                          ) : (
                            <>
                              <i
                                className="fa-solid fa-indian-rupee-sign"
                                style={{ color: "#349bc7" }}
                              ></i>{" "}
                              {product.InsurancePremiums[0].TotalAmount}
                            </>
                          )}
                        </p>
                      </div>
                      <button
                        className="btn btn-primary align-self-end"
                        onClick={() => setPurchaseProduct(product)}
                      >
                        Purchase
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div>
                <h4 className="text-danger fw-semibold text-center">
                  No Products Available
                </h4>
              </div>
            )}
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="exLargeModal"
        tabIndex="-1"
        aria-hidden="true"
        aria-labelledby="exampleModalLabel4"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          {selectedPolicy && (
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title" id="exampleModalLabel4">
                  Upload Document for {selectedPolicy.PoliciesProductName}
                </h4>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => handleCloseModal()}
                ></button>
              </div>

              <form
                className="form-group custom-form p-3"
                onSubmit={handleFileSubmit}
              >
                <div className="row g-2">
                  <div className="col-12 col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter COI Number"
                      value={PolicyCOINumber}
                      onChange={(e) => setPolicyCOINumber(e.target.value)}
                      required
                    />
                  </div>
                  <div className="col-12 col-md-6">
                    <input
                      type="file"
                      className="form-control"
                      required
                      onChange={(e) => handleUploadChange(e)}
                    />
                  </div>
                </div>
                <button
                  type="submit"
                  className="btn btn-success mt-2"
                  disabled={!file || !PolicyCOINumber}
                >
                  {policyUploadLoad ? (
                    <div className="spinner-border text-white" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  ) : (
                    "UPLOAD"
                  )}
                </button>
              </form>
            </div>
          )}
        </div>
      </div>

      {/* <div
        style={{
          position: "sticky",
          bottom: "10px",
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
        }}
      >
        <button
          className="btn btn-dark"
          data-bs-toggle="modal"
          data-bs-target="#exLargeModalPurchase"
          onClick={() => setPurchaseProduct()}
        >
          Purchase
        </button>
      </div> */}

      <TableContainer component={Paper}>
        <ConfirmationDialogDelete
          open={confirmationOpen}
          title={confirmationData.title}
          message={confirmationData.message}
          onConfirm={confirmationData.onConfirm}
          onCancel={() => setConfirmationOpen(false)}
        />
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert onClose={handleSnackbarClose} severity="success">
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </TableContainer>
    </>
  );
}
